import { BlockerColumn } from './../../Models/BlockerColumns';
import { CSGProduct } from 'src/Models/CSGProduct';
import { Area, SGSArea } from '../../Models/Area';
import { EOUModel } from '../../Models/EOUModel';
import { SolutionArea } from '../../Models/SolutionArea';
import { SubState } from '../../Models/SubState';
import { Priority } from '../../Models/Priority';
import { CustomIndustry } from '../../Models/CustomIndustry';
import { Industry } from '../../Models/Industry';
import { MilestoneStatus } from '../../Models/MilestoneStatus';
import { HelpNeeded } from '../../Models/HelpNeeded';
import { HelpNeededOpportunity } from '../../Models/HelpNeededOpportunity';
import { MilestoneWorkload } from '../../Models/MilestoneWorkload';
import { FinancialYear } from 'src/Models/FinancialYear';
import { Quarter } from 'src/Models/Quarter';
import { Top5Ask } from 'src/Models/Top5Ask';
import { AzurePriority } from 'src/Models/AzurePriority';
import { TopicCategory } from 'src/Models/TopicCategory';
import { Organization } from 'src/Models/Organization';
import { LogicalOperator } from 'src/Models/LogicalOperator';
import { ADOField } from 'src/Models/Field';
import { SQLOperator } from 'src/Models/SQLInOperator';
import { FieldValue } from 'src/Models/FieldValue';
import { ActionCategory } from '../../Models/ActionCategory';
import { AMM_CurrencyWithLocale } from 'src/Common/Models/CurrencyWithLocale';
import {
  ADOColumnNames,
  Application,
  AssesmentServiceStatus,
  AssesmentType,
  EcifStatus,
  EngineeringStatus,
  EngineeringContacts,
  EcifStatusIfCma,
  EcifRequestedServiceStatus,
  FeedbackType,
  InterestedInRenewing,
  InterestedInOtherECIF,
  IntentToMoveToCloud,
  IfNoStateReason,
  IfYesStateReason,
  InterestInAssessment,
  Patner,
  PatternGroup,
  Program,
  ScopeOld,
  ADOStatus,
  Triage,
  Activity,
  CloudIntentreason,
  CompleationStatusIfCombined,
  NonRenewingReason,
  MeetingTypeOrigin,
  WorkloadType,
  AssistedMigrationreason,
  IsAssistedMigrationAnOption,
  Reason,
  //Microsoft.__
  Issue,
  FoundIn,
  IntegrationBuild,
  TestSuitType,
  AutomationStatus,
  ValueArea,
  TrueFalse,
  Rating,
  WorkItemType,
  BoardColumn,
  Severity,
  ClosedStatus,
  StateCode,
  ClosedStatusCode,
  AreaPath,
  IterationPath,
  Theme,
  AdditionalTheme,
  AssociatedContextType,
  DateDropDown,
  ActionOption,
  MigrationType,
  MigrationServiceStatus,
  EcifStatusIfFam,
  MeetingSubType,
  AssignedToCorpValues,
  ActionType,
  ApplicationType,
  InterestedAssistedMigrationreason,
  ServiceTreeOffering,
  YesOrNo,
  MilestoneReason,
  IdInValue,
  DeliveryBlockers,
  EngagementCategory,
  EngagementRegion,
  ScenarioCohort,
  FirstPartyOffering,
  FirstPartySolution,
  ThirdPartySolution,
  OpportunityStage,
  OpportunityIntent,
  SOObjective,
  ProjectName,
  PrivateMeetingTypeAreaPathMapping,
  PrivateSolutionAreaMapping,
  OperatingUnit,
  NonRecurringValues,
  BusinessDivision,
  IntakeType,
  ProblemType,
  StrategicCategory,
  RolesImpacted,
  ToolsImpacted,
  L1BusinessProcess,
  L2BusinessProcess,
  L3BusinessProcess,
  ExecutingTeamName,
  RequestType,
  CloudImpacted,
  NominationTypeValues,
  RequestTypeValues,
  RequestUrgencyValues,
  UOMValues,
  DealTypeValues,
  PreferredRegionValues,
  ModelValues,
  DecisionValues,
  TimeZoneValues,
  DeliveryMethodValues,
  EntityTypeValues,
  TypeOfFunds,
  ECIFProgram,
  EcifActivityType,
  RaidStatus,
  RaidPriority,
  csrSecondaryEscalationReason,
  csrTertiaryEscalationReason,
  csrHasD365,
  csrHasUnified,
  MSXAOAIWorkloads,
  MaaS_IsExistingAccount,
  GPS_Product,
  GPS_AskType,
  GPS_CustomerSegment,
  GPS_SolutionArea,
  GPS_Business,
  GPS_DiscussionType,
  GPS_RequestType,
  GPS_Partner_Type,
  GPS_Calc_Partner_Type,
  GPS_InvestmentType,
  GPS_SurveyOption,
  GPS_Control_Type,
  GPS_PIRDecision,
  GPS_Funding,
  GPS_FundingSource,
  GPS_InvestmentComplexity,
  GPS_Areas,
  GPS_EngagementType,
  GPS_PayoutType,
  GPS_Stage,
  GPS_MCEM_Stage,
  GPS_ChangeRequestType,
  SchAccountTeamBriefingStatus,
  SchCustomerBriefingStatus,
  SchGrowthShapingSteps,
  SchGrowthShapingState,
  SchPrimaryReasonForBlockedOrAtRisk,
  SMCCSubSegment,
  SMCCSegment,
  SMCCRouteMapping,
  ECIF_DealStructure,
  ECIF_RequestReason,
  ECIF_ApprovedOrRejectedValues,
  EmailNotificationTemplates,
  BudgetProgramName,
  LicensingMechanism,
  UseCase,
  WorkType,
  CustomerPartnerLocation,
  ImpactType,
  ROBState,
  ROBSubState,
  ApprovalType,
  ReferralOpportunityKeyword,
  ReferralDeDupSubSegmentList,
  BlockerTypeValues,
  CustomerPriorityValues,
  AccountCohort,
  CustomerCommitmentStatus,
  DCRegionFrom,
  DCRegionTo,
  TierOptions,
  SubTierOptions,
  NonAISKUValues,
  NonAIRequestTypeValues,
  NonAIRegionalZonalValues,
  NonAIUOMValues,
  NonAIWorkloadImpactValues,
  NonAIV6SKUValues,
  NonAIActionOwnerMappingValues,
  PSRequestTypesOptions,
  PSCampainOptions,
  PSDeliveryLanguageOptions,
  PSPartnerTypeOptions,
  PSCountryOptions,
  PSActionOwnerMappingOptions,
  PSPlanStatusOptions,
  PSModelOptions,
  PSAccountTypeOptions,
  PSMeetingCadenceFrequencyOptions,
  IAMMActionPriorities,
  GrowthShapingETA,
  TimezoneOptions,
  IAMM_Exceptiondecision,
  IAMM_Exceptiontype,
  IAMMSellerAttestation,
  IAMM_ACO_ReleaseStructure,
  IWillingToSignNewMACC,
  IAMM_CreditExpiration,
  IAMM_NBARScenario,
  IAMM_NBAR_Status,
  IAMM_NBAR_RejectionReason,
  IAMM_NBAR_ReasonForDelayBeyond3Months,
  IAMM_NBAR_CommitmentStatus,
} from '../../Models/DropdownFields';
import {
  GPS_PaymentProgram,
  GPS_EarningType,
  GPS_PaymentMethod,
  GPS_TCType,
  GPS_ComplexityLevel,
  GPS_AccountingTreatment,
} from 'src/manageAction/interfaces/GPS';
import { store, StoreState } from '../../Store';
import { StateCategoryEnum, WorkItemState } from 'src/Models/WorkItemState';
import { OpportunityStatus } from 'src/Models/OpportunityStatus';
import { HelpNeededApex } from 'src/Models/HelpNeededApex';
import { CustomerEngagementActivity } from 'src/Models/CustomerEngagementActivity';
import { ReferredTo } from 'src/Models/ReferredTo';
import { CollabAppsContest } from 'src/Models/CollabAppsContest';
import { RB_InfraLocation } from 'src/Models/RB_InfraLocation';
import { MaaS_OU } from 'src/Models/MaaS_OU';
import { MaaS_MCEM } from 'src/Models/MaaS_MCEM';
import { MaaS_Industry } from 'src/Models/MaaS_Industry';
import { MaaS_Segment } from 'src/Models/MaaS_Segment';
import { MaaS_SubRole } from 'src/Models/MaaS_SubRole';
import { RB_Technology } from 'src/Models/RB_Technology';
import { RB_Tier } from 'src/Models/RB_Tier';
import { RB_GeneralCategory } from 'src/Models/RB_GeneralCategory';
import { RB_TicketReason } from 'src/Models/RB_TicketReason';
import { RB_Area } from 'src/Models/RB_Area';
import { RB_Region } from 'src/Models/RB_Region';
import { RB_Country } from 'src/Models/RB_Country';
import { MeetingType } from 'src/Models/MeetingType';
import { csrPrimaryWorkload } from '../../Models/CSRPrimaryWorkload';
import { csrHasFasttrack } from '../../Models/CSRHasFasttrack';
import { csrEscalationReason } from 'src/Models/CSREscalationReason';
import { MaaS_RequestTypes } from 'src/Models/MaaS_RequestTypes';
import { MaaS_Role } from 'src/Models/MaaS_Role';
import { MaaS_Area } from 'src/Models/MaaS_Area';
import { MaaS_ExistingAccountValues } from 'src/Models/MaaS_ExistingAccountValues';
import { MaaS_SpecificCountry } from 'src/Models/MaaS_SpecificCountry';
import {
  CoSellActivity,
  CoSellDealStatus,
  CoSellDeliveryLanguageSupport,
  CoSellMCEMSalesStage,
  CoSellPartnerArea,
  CoSellPartnerCountry,
  CoSellPartnerEngaged,
  CoSellPartnerRegion,
  CoSellSubCategoryTopic,
  CoSellRequestType,
  CoSellRequestCategory,
} from 'src/Models/CoSellModels';
import { Language } from 'src/Models/Language';

import { MACC_Reason_for_Exceptions } from 'src/Models/MACC_ReasonforException';
import { CoSellBusinessRulesHelper } from 'src/Models/CosellDynamicValidation';
import {
  AMM_Aaofertype,
  AMM_ActionTaken,
  AMM_CancellationReason,
  AMM_CommunicationPreference,
  AMM_HelpType,
  AMM_CustomerCommitment,
  AMM_DealStructure,
  AMM_DisqualificationReason,
  AMM_DoYouWantToRequestAcoInAdditionToEcif,
  AMM_Esi,
  AMM_Fta,
  AMM_Microsoftdefenderforcloud,
  AMM_MigrationPartnerAttached,
  AMM_NextBestAction,
  AMM_Offer,
  AMM_OfferEnginestatus,
  AMM_Pendingactionfrom,
  AMM_PreOrPost,
  AMM_PrimaryAzureVirtualMachineVmSeries,
  AMM_Program,
  AMM_RejectionReason,
  AMM_RequestType,
  AMM_ScopeOfWork,
  AMM_SupportRegion,
  AMM_SupportedScenario,
  AMM_TypeOfFundingNeeded,
  AMM_WillThisRequestRequireAdditionalAttendees,
  AMM_YesOrNo,
  AMM_RequestReason,
  AMM_AzureFutureGrowthOffer,
  AMM_ServiceLocation,
  AMM_PrimarySolutionPlaySupporting,
  AMM_FinancialYear,
  AMM_SapOffer,
  AMM_AvsOfferRequestCorrespond,
  AMM_ECIFFutureGrowthOffer,
  Amm_primaryazurevirtualmachinevmseries,
  AMM_OfferEngineType,
  Amm_SubStates,
  AMM_OfferDeskRegion,
  AMM_Partner,
  AMM_AzureRegion,
  AMM_NodeType,
  AMM_ReservedInstances,
  AMM_FTTSettings,
  AMM_CPUOverSubscription,
  AMM_Currency,
  Amm_RVToolsExport,
  AMM_AlreadyRunningAtleast1AVSClusterInTheTargetRegion,
  AMM_ProjectScenarioSelection,
  AMM_IsNominationforFactoryAssessment,
  AMM_DeliveryGroupSelection,
  AMM_ConditionsApplyForProject,
  AMM_ECIFFactoryConditions,
  AMM_FactoryBenefits,
  AMM_ReasonForNotAcceptingSplit,
  AMM_PartnerSpecializationConfirmation,
  AMM_Service,
  AMM_SIpartners,
  AMM_Platform,
  AMM_SMEDecision,
  AMM_CompeteScenario,
  AMM_AnticipatedDeliveryMethod,
  AMM_AccountTeamAlignment,
  AMM_CustomerInterest,
  AMM_LicensingProgram,
  AMM_CSPPartner,
  AMM_ACOScenarioSelection,
  AMM_SynapseDedicatedPoolworkload,
  AMM_AVSPilotRegionRequested,
  AMM_AVSPilotSKURequested,
  AMM_SSCACOOffer,
  AMM_BigArea,
} from 'src/Models/AMMDropdownFields';
import { MaaS_SubSegment } from 'src/Models/MaaS_SubSegment';
import {
  ActionownerGroup,
  RequestedRegionValues,
  SubRegion,
  Region,
  Segment,
  ROBSubRegion,
} from '../manageViews/interfaces/DropdownData';
import { UATDisplayColumn } from 'src/Models/DisplayColumns';
import { MaaS_EventTypes } from 'src/Models/MaaS_EventTypes';
import {
  PMYTApprover,
  PMYTSG,
  PMYTSGApproverMapping,
  PMYTSourceOfInvestment,
} from 'src/Models/PMYTModels';
import {
  RequestDeploymentFrequencyValues,
  RequestDwrRecommendationValues,
  RequestInterconnectedClusterValues,
  RequestIscustomerneedvalidatedforNCseriesValues,
  RequestLLMOrLMMValues,
  RequestMainUseCategoriesValues,
  RequestNonGpuAcrTypeValues,
  RequestRegionFlexibilityTypeValues,
  RequestValidatedbyAIgbbsValues,
  RequestVMsTypeValues,
} from 'src/manageAction/interfaces/DropdownData';
import { UATConstants } from './UATConstants';
import { RobActionCategory } from 'src/Models/RobActionCategory';
import { InsightsClient } from 'src/utils/InsightsClient';
import { TraceMessages } from './TelemetryConstants';
import { SuperRevSumDivision } from 'src/Models/SuperRevSumdivision';
import { SalesPlay } from './SalesPlay';
import { MDC_Reason_for_Exceptions } from 'src/Models/MDC_ReasonforException';
export function GetActionOptionColumns() {
  const dict = {};
  dict['Area'] = GenerateOptions(GetAreas(), 'area');
  const EOU = GenerateOptions(GetEOUS(), 'eou');
  dict['EOU'] = EOU.filter((c, index) => {
    return EOU.indexOf(c) === index;
  });
  dict['Solution Area (MSX)'] = GenerateOptions(GetSolutionAreas(), 'solutionArea');
  dict['Solution Area (UAT)'] = GenerateOptions(GetSolutionAreas(), 'solutionArea');
  dict['Business Division'] = GenerateOptions(GetBusinessDivisionOptions(), 'businessDivision');
  dict['Intake'] = GenerateOptions(GetIntakeOptions(), 'intake');
  dict['Roles Impacted'] = GenerateOptions(GetRolesImpactedOptions(), 'rolesImpacted');
  dict['Tools Impacted'] = GenerateOptions(GetProcessOrToolsImpactedOptions(), 'toolsImpacted');
  dict['Problem Type'] = GenerateOptions(GetProblemTypeOptions(), 'problemType');
  dict['Strategic Category'] = GenerateOptions(GetStrategicCategoryOptions(), 'strategicCategory');
  dict['L1 Business Process (BPAL1)'] = GenerateOptions(GetL1BusinessProcessOptions(), 'bpaL1');
  dict['L2 Business Process (BPAL2)'] = GenerateOptions(GetL2BusinessProcessOptions(), 'bpaL2');
  dict['L3 Business Process (BPAL3)'] = GenerateOptions(GetL3BusinessProcessOptions(), 'bpaL3');
  dict['Executing TeamName'] = GenerateOptions(GetExecutingTeamNameOptions(), 'executingTeamName');
  dict['Custom Industry'] = GenerateOptions(GetCustomIndustryOptions(), 'customIndustry');
  dict['Industry'] = GenerateOptions(GetIndustryOptions(), 'industry');
  dict['Milestone Status'] = GenerateOptions(GetMilestoneStatusOptions(), 'mileStoneStatus');
  dict['Help Needed'] = GenerateOptions(GetHelpNeededOptions(), 'helpNeeded');
  dict['Milestone Workload'] = GenerateOptions(GetMilestoneWorkloadOptions(), 'milestoneWorkload');
  dict['Milestone Reason'] = GenerateOptions(GetMilestoneReason(), 'milestoneReason');
  dict['Opportunity Stage'] = GenerateOptions(GetOpportunityStageOptions(), 'opportunityStage');
  dict['Request Type'] = GenerateOptions(GetRequestTypeOptions(), 'requestType');
  dict['AOAI_Model'] = GenerateOptions(GetActiveModelValues(), 'model');
  dict['Request Urgency'] = GenerateOptions(GetRequestUrgencyValues(), 'displayName');
  dict['Unit of Measurement'] = GenerateOptions(GetUOMValues(), 'displayName');
  dict['Priority'] = GenerateOptions(GetPriorityOptions(), 'actionPriority');
  dict['SubRegion'] = GenerateOptions(GetSubRegionOptions(), 'subRegion');
  dict['State'] = GenerateOptions(GetWorkItemStates(), 'Name');
  dict['Sub State'] = GenerateOptions(GetSubStateOptions(), 'subState');
  dict['FY'] = GenerateOptions(GetFinancialYearOptions(), 'fy');
  dict['Quarter'] = GenerateOptions(GetQuarterOptions(), 'quarter');
  dict['Theme'] = GenerateOptions(GetThemeOptions(), 'theme');
  dict['Program'] = GenerateOptions(GetPrograms(), 'program');
  dict['QBC Top 5 Ask'] = GenerateOptions(GetTop5AskOptions(), 'qbcTop5Ask');
  dict['Azure Priority'] = GenerateOptions(GetAzurePriorityOptions(), 'azurePriority');
  dict['Topic Category'] = GenerateOptions(GetTopicCategoryOptions(), 'topicCategory');
  dict['Additional Theme'] = GenerateOptions(GetAdditionalTheme(), 'additionalTheme');
  dict['LT Escalation'] = ['true', 'false'];

  dict['Action Category'] = GenerateOptions(GetActionCategories(), 'actionCategory');
  dict['Meeting Type'] = GenerateOptions(GetMeetingTypeOrigin(), 'meetingTypeOrigin');
  dict['Meeting SubType'] = GenerateOptions(GetMeetingSubTypes(), 'meetingSubType');
  dict['Assign To Corp'] = ['Yes', 'No'];
  dict['Business Proposal'] = ['true', 'false'];
  dict['Offer Related'] = ['true', 'false'];
  dict['Help Needed Opportunity'] = GenerateOptions(
    GetHelpNeededOpportunityOptions(),
    'helpNeeded'
  );
  dict['Delivery Blockers'] = GenerateOptions(GetDeliveryBlockers(), 'deliveryBlocker');
  dict['Triage'] = GenerateOptions(GetTriageValues(), 'triage');
  dict['Feedback Type'] = GenerateOptions(GetFeedbackTypeOptions(), 'feedbackType');
  dict['Engineering Status'] = GenerateOptions(GetEngineeringStatus(), 'engineeringStatus');
  dict['Is Blocked'] = ['Yes', 'No'];
  dict['Publicly Documented'] = ['Yes', 'No'];
  dict['CAE Engagement Category'] = GenerateOptions(
    GetEngagementCategoryOptions(),
    'engagementCategory'
  );
  dict['CAE Engagement Region'] = GenerateOptions(GetEngagementRegionOptions(), 'engagementRegion');
  dict['CAE Scenario Cohort'] = GenerateOptions(GetScenarioCohortOptions(), 'scenarioCohort');
  dict['CAE First Party Offering'] = GenerateOptions(
    GetFirstPartyOfferingOptions(),
    'firstPartyOffering'
  );
  dict['CAE First Party Solution'] = GenerateOptions(
    GetFirstPartySolutionOptions(),
    'firstPartySolution'
  );
  dict['CAE Third Party Solution'] = GenerateOptions(
    GetThirdPartySolutionOptions(),
    'thirdPartySolution'
  );
  dict['Additional Area'] = GenerateOptions(GetAreas(), 'area');
  dict['Additional EOU'] = GenerateOptions(GetEOUS(), 'eou');
  dict['Opportunity Intent'] = GenerateOptions(GetOpportunityIntentOptions(), 'opportunityIntent');
  dict['Operating Unit'] = GenerateOptions(GetOperatingUnit(), 'operatingUnit');
  dict['Cloud Impacted'] = GenerateOptions(GetCloudImpacted(), 'cloudImpacted');
  dict['Feedback'] = ['true', 'false'];
  dict['Feature Parity Request'] = ['true', 'false'];
  dict['Non Recurring'] = ['Yes', 'No'];
  dict['Help Needed APEX'] = GenerateOptions(GetHelpNeededApexOptions(), 'helpNeeded');
  dict['When Does Customer Want To Engage?'] = GenerateOptions(
    GetCustomerEngagementActivityOptions(),
    'customerEngagementActivity'
  );
  dict['Part of Collab Apps Contest'] = GenerateOptions(
    GetCollabAppsContestOptions(),
    'collabAppsContest'
  );
  dict['Referred To'] = GenerateOptions(GetReferredToOptions(), 'referredTo');
  dict['Is an Executive sponsor from customer to this engagement?'] = ['Yes', 'No'];
  dict['Are there IT and Business stakeholders for this engagement?'] = ['Yes', 'No'];
  dict['Cloud vs Onprem'] = GenerateOptions(GetCloudVsOnpremOptions(), 'rb_infraLocation');
  dict['GeneralCategory'] = GenerateOptions(GetGeneralCategoryOptions(), 'rb_GeneralCategory');
  dict['Ticket Reason'] = GenerateOptions(GetTicketReasonOptions(), 'rb_TicketReason');
  dict['RB Area'] = GenerateOptions(GetRBAreaOptions(), 'rb_Area');
  dict['Region'] = GenerateOptions(GetRBAreaOptions(), 'rb_Region');
  dict['Country'] = GenerateOptions(GetCountryOptions(), 'rb_Country');
  dict['Languages'] = GenerateOptions(GetLanguageOptions(), 'languages');
  dict['csrPrimaryWorkload'] = GenerateOptions(
    GetCSRPrimaryWorkloadOptions(),
    'csrPrimaryWorkload'
  );
  dict['Additional Theme'] = GenerateOptions(GetAdditionalTheme(), 'additionalTheme');
  dict['csr Has Fasttrack'] = GenerateOptions(GetCSRHasFasttrackOptions(), 'csrHasFasttrack');
  dict['CSR Escalation'] = GenerateOptions(GetCSREscalationReason(), 'csrEscalationReason');
  dict['CSR Has Unified'] = GenerateOptions(GetHasUnified(), 'csrHasUnified');
  dict['CSR Has D365'] = GenerateOptions(Get365DEEDE(), 'csrHasD365');
  dict['CoSell_Activity'] = GenerateOptions(GetCoSellActivity(), 'CoSellActivity');
  dict['CoSell BusinessRules Helper'] = GenerateOptions(
    GetCoSellBusinessRulesHelper(),
    'CoSellBusinessRulesHelper'
  );
  dict['CoSell_SubCategoryTopic'] = GenerateOptions(
    GetCoSellSubCategoryTopic(),
    'subCategoryTopic'
  );

  const filteredCategories = GetCoSellRequestCategory().filter(
    (item) =>
      item.requestCategory !== UATConstants.PlaceholdersAndTitles.RenamedCosellSMCRequestCategory
  );

  dict['CoSell_RequestCategory'] = GenerateOptions(filteredCategories, 'requestCategory');
  dict['CoSell_PartnerEngaged'] = GenerateOptions(GetCoSellPartnerEngaged(), 'partnerEngaged');
  dict['CoSell_DeliveryLanguageSupport'] = GenerateOptions(
    GetCoSellDeliveryLanguageSupport(),
    'deliveryLanguageSupport'
  );
  dict['CoSell_PartnerRegion'] = GenerateOptions(GetCoSellPartnerRegion(), 'partnerRegion');
  dict['CoSell_PartnerArea'] = GenerateOptions(GetCoSellPartnerArea(), 'partnerArea');
  dict['CoSell_PartnerCountry'] = GenerateOptions(GetCoSellPartnerCountry(), 'partnerCountry');
  dict['CoSell_DealStatus'] = GenerateOptions(GetCoSellDealStatus(), 'dealStatus');
  dict['CoSell_MCEMSalesStage'] = GenerateOptions(GetCoSellMCEMSalesStage(), 'mCEMSalesStage');
  dict['MaaS_Request_Type'] = GenerateOptions(GetMaaSRequestTypeOptions(), 'MaaSRequestType');
  dict['MaaS_Role'] = GenerateOptions(GetMaaSRoleOptions(), 'Role');
  dict['MaaS_Marketer_Role'] = GenerateOptions(GetMaaSSubRoleOptionsByRole('Marketer'), 'SubRole');
  dict['MaaS_Seller_Role'] = GenerateOptions(GetMaaSSubRoleOptionsByRole('Seller'), 'SubRole');
  dict['MaaS_Area'] = GenerateOptions(GetMaaSAreaOptions(), 'Area');
  dict['MaaS_Industry'] = GenerateOptions(GetMaaSIndustryOptions(), 'Industry');
  dict['MaaS_Segment'] = GenerateOptions(GetMaaSSegmentOptions(), 'Segment');
  dict['MaaS_OU'] = GenerateOptions(GetMaaSOUOptions(), 'MaaS_OU');
  dict['MaaS_MCEM_Stage'] = GenerateOptions(GetMaaSMCEMOptions(), 'MCEM');
  dict['MaaS_IsInterestedOrgChat'] = GenerateOptions(GetTrueFalse(), 'trueFalse');
  dict['MaaS_IsInterestedAccountProfile'] = GenerateOptions(GetTrueFalse(), 'trueFalse');
  dict['MaaS_SpecificCountry'] = GenerateOptions(GetMaasSpecificCountryOptions(), 'CountryName');
  dict['MaaS_TechTargetexistingAccount'] = GenerateOptions(
    GetMaaSMaaSIsExistingAccOptions(),
    'option'
  );
  dict['MaaS_UpdateExistingAccount'] = GenerateOptions(
    GetMaaSExistingAccountValues(),
    'ExistingAccountValues'
  );
  dict['PMYT_Areas'] = GenerateOptions(GetPMYTArea(), 'pmytArea');
  dict['PMYT_SourceOfInvestment'] = GenerateOptions(
    GetPMYTSourceOfInvestment(),
    'pmytSourceOfInvestment'
  );
  dict['PMYT_SolutionPlays'] = GenerateOptions(GetPMYTSolutionPlays(), 'pmytSolutionPlay');
  dict['PMYT_Industries'] = GenerateOptions(GetPMYTIndustry(), 'pmytIndustry');
  dict['PMYT_CustomerSegment'] = GenerateOptions(GetPMYT_CustomerSegment(), 'pmytCustomerSegment');
  dict['PMYT_PartnerType'] = GenerateOptions(GetPMYT_PartnerType(), 'pmytPartnerType');
  dict['Subsidiary'] = GenerateOptions(GetSubRegionOptions(), 'subRegion');
  dict['Account Team Briefing Status'] = GenerateOptions(
    GetSchAccountTeamBriefingStatus(),
    'accountTeamBriefingStatus'
  );
  dict['Customer Briefing Status'] = GenerateOptions(
    GetSchCustomerBriefingStatus(),
    'customerBriefingStatus'
  );
  dict['Growth Shaping Steps'] = GenerateOptions(GetSchGrowthShapingSteps(), 'growthShapingSteps');
  dict['Campaign'] =  GenerateOptions( GetPartnerSkillingCampaignOptions(), 'rS_campaign');
  dict['Partner Country1'] = GenerateOptions(GetPartnerSkillingCountryOptions(),'rS_partnercountry');
  dict['Partner Region1'] = GenerateOptions(GetCoSellPartnerRegion(), 'partnerRegion');
  dict['Delivery Language'] =GenerateOptions(GetPartnerSkillingDeliveryLanguageOptions(), 'rS_deliverylanguage');
  dict['Skilling Plan Attachment'] = ['Yes', 'No'];
  return dict;
}

export function GenerateOptions<T>(dataArray: T[], prop: string): string[] {
  const optionsArray: string[] = [];
  if (dataArray && dataArray.length > 0) {
    dataArray.forEach((item: T) => {
      if (item[prop] && item[prop].indexOf('Select') === -1) {
        optionsArray.push(item[prop]);
      }
    });
  }
  return optionsArray;
}

export const GetDropdownOptions = <T>(type: string): T[] => {
  try {
    const storeState = store.getState() as StoreState;
    const dropdownData = storeState.dropdownData;
    if (!dropdownData || !dropdownData[type]) {
      InsightsClient.trackTrace({
        message: TraceMessages.dropdownDataKeyMissing(type),
      });
      return [];
    }

    return dropdownData[type] as T[];
  } catch (error) {
    InsightsClient.trackTrace({
      message: TraceMessages.dropdownDataFetchError(type),
    });
    return [];
  }
};

export const GetStateIdByCategory = (stateCategory: StateCategoryEnum): number => {
  const state = GetWorkItemStates().find((g) => g.Category === stateCategory);
  if (state) {
    return state.id;
  } else {
    return -1;
  }
};

export const GetAreaPaths = (): AreaPath[] => GetDropdownOptions('assignedTeams');

export const GetAreas = (): Area[] => GetDropdownOptions('areas');
export const GetSGSAreas = (): SGSArea[] => GetDropdownOptions('sgS_Areas');
export const GetIsvAreas = (): Area[] => GetDropdownOptions('IsvAreaApprover');

export const GetTenantAreas = (tenantStr: string): Area[] => {
  const areas = GetDropdownOptions('areas');
  return areas?.filter((g) => g.tenant && g.tenant.includes(tenantStr));
};

export const GetROBAreas = (): Area[] => GetDropdownOptions('rob_area');

export const GetActionownerGroups = (): ActionownerGroup[] =>
  GetDropdownOptions('mcapsROBActionOwnerGrp');

export const GetCSGProducts = (): CSGProduct[] => GetDropdownOptions('csgProductList');

export const GetCSRPrimaryWorkloadOptions = (): csrPrimaryWorkload[] =>
  GetDropdownOptions('csrPrimaryWorkload');
export const GetCSRHasFasttrackOptions = (): csrHasFasttrack[] =>
  GetDropdownOptions('csrHasFasttrack');
export const GetCSREscalationReason = (): csrEscalationReason[] =>
  GetDropdownOptions('csrEscalationReason');
export const GetCSRSecondaryEscalationReason = (): csrSecondaryEscalationReason[] =>
  GetDropdownOptions('csrSecondaryEscalationReason');
export const GetTertiaryEscalationReason = (): csrTertiaryEscalationReason[] =>
  GetDropdownOptions('csrTertiaryEscalationReason');
export const GetHasUnified = (): csrHasUnified[] => GetDropdownOptions('csrHasUnified');
export const Get365DEEDE = (): csrHasD365[] => GetDropdownOptions('csrHasD365');

export const GetApplications = (): Application[] => GetDropdownOptions('applicaions');

// Id 1 and 2 are by default
export const GetBlockerColumns = (): BlockerColumn[] =>
  GetDropdownOptions('downloadTemplateOptions');

export function GetSGSDCRegionFromCount(): number {
  const blockerColumns: BlockerColumn[] = GetBlockerColumns() ?? [];
  const nameRegex = /^DC\s*Region\s*From(?:\s+[1-9]\d*)?$/i;

  const count = blockerColumns.reduce((acc, item) => {
    const tenant = item?.tenant;
    const name = typeof item?.name === 'string' ? item.name.trim() : '';

    if (tenant?.includes('sgs') && nameRegex.test(name)) {
      return acc + 1;
    }
    return acc;
  }, 0);

  return count;
}

export function GetColumnMapper() {
  const data = {
    meetingtype: 'Meeting Type',
    milestoneEstimatedDate: 'Milestone Est. Date',
  };
  return data;
}

export const GetEOUS = (): EOUModel[] => GetDropdownOptions('eous');

export function GetEOUSById(areaId: number): EOUModel[] {
  const eous = GetEOUS();
  return eous.filter((g) => g.areaId === areaId);
}
export function GetSegmentById(areaId: string): MaaS_Segment[] {
  const segments = GetMaaSSegmentOptions();
  return segments.filter((g) => g.MaaS_SegmentAreaIds?.includes(areaId));
}

export function GetOUById(segmentId: string, areaId: number | string | undefined, subSegmentId: string): MaaS_OU[] {
  const ous = GetMaaSOUOptions();
  return ous.filter(
    (g) =>
      g.MaaS_SubSegment_ID.split(',').includes(subSegmentId) &&
      g.MaaS_Segment_ID.includes(segmentId) &&
      g.MaaS_Area_ID == areaId
  );
}

export function GetSubSegmentById(segmentId: string, areaId: number | string | undefined): MaaS_SubSegment[] {
  const ous = GetMaaSSubSegementOptions();
  return ous.filter(
    (g) => g.MaaS_SegmentIds.includes(segmentId) && areaId !== undefined && g.MaaS_AreaIds.includes(areaId.toString())
  );
}

export function GetActionCategoryByName(helpNeeded: string): HelpNeeded {
  const helpNeededOptions = GetHelpNeededOptions();
  return helpNeededOptions.filter((g) => g.helpNeeded === helpNeeded)[0];
}

export function GetStateIdByName(state: string): WorkItemState {
  const stateOptions = GetWorkItemStates();
  return stateOptions.filter((g) => g.Name === state)[0];
}

export function GetBpaL1IdByName(BpaL1: string): L1BusinessProcess {
  const BpaL1Options = GetL1BusinessProcessOptions();
  return BpaL1Options.filter((g) => g.bpaL1 === BpaL1)[0];
}

export function GetBpaL2IdByName(BpaL2: string): L2BusinessProcess {
  const BpaL2Options = GetL2BusinessProcessOptions();
  return BpaL2Options.filter((g) => g.bpaL2 === BpaL2)[0];
}

export function GetAreaPathIdByName(area: string): AreaPath {
  const areaOptions = GetAreaPaths();
  return areaOptions?.filter((g) => g.areaPathName === area)[0];
}

// export function GetSubStatesById(stateId: number): SubState[] {
//   let stateOptions = GetSubStateOptions();
//   return stateOptions.filter((g) => (g.stateId === stateId ));
// }

export function GetBpaL2ByBpaL1Id(BpaL1Id: number): L2BusinessProcess[] {
  const BpaL2Options = GetL2BusinessProcessOptions();
  return BpaL2Options.filter((g) => g.bpaL1ID === BpaL1Id);
}
export function GetBpaL3ByBpaL2Id(BpaL2Id: number): L3BusinessProcess[] {
  const BpaL3Options = GetL3BusinessProcessOptions();
  return BpaL3Options.filter((g) => g.bpaL2ID === BpaL2Id);
}

export function GetSubStatesById(stateId: number, areapathId?: string): SubState[] {
  const stateOptions = GetSubStateOptions();
  let stateOptionsFiltered: SubState[];
  stateOptionsFiltered = stateOptions?.filter(
    (g) => g.stateId === stateId && g.areapathID == areapathId
  );
  if (stateOptionsFiltered?.length == 0) {
    stateOptionsFiltered = stateOptions.filter(
      (g) => g.stateId === stateId && g.areapathID == null
    );
  }
  return stateOptionsFiltered;
}

export const GetSolutionAreas = (): SolutionArea[] => GetDropdownOptions('solutionAreas');

export const GetGPSSolutionAreas = (): GPS_SolutionArea[] => {
  // Get solutionAreas from the dropdown data

  const solutionAreasData = GetDropdownOptions<SolutionArea>('solutionAreas');
  // Filter for GPS tenant and map to GPS_SolutionArea format
  if (solutionAreasData && solutionAreasData.length > 0) {
    return solutionAreasData
      .filter((item: SolutionArea) => {
        // Include items where tenant is null/undefined OR includes 'gps'
        const hasGpsTenant = item.tenant && item.tenant.toLowerCase().includes('gps');
        return hasGpsTenant && item.solutionArea; // Also ensure solutionArea exists
      })

      .map((item: SolutionArea) => ({
        solutionareauat: item.solutionArea,
        id: item.id,
        isPrivate: item.isPrivate,
      }));
  }
  // Fallback hardcoded data if API doesn't return anything
  return [
    { id: 1, solutionareauat: 'Security', isPrivate: false },
    { id: 2, solutionareauat: 'Cloud and AI Platforms', isPrivate: false },
    { id: 3, solutionareauat: 'AI Business Solutions', isPrivate: false },
    { id: 4, solutionareauat: 'Other', isPrivate: false },
  ];
};
export const GetPrivateSolutionAreaPathMappings = (): PrivateSolutionAreaMapping[] =>
  GetDropdownOptions('privateSolutionAreaAreaPathMapping');

export const GetSolutionAreasByAreaPath = (areaPathId: number): SolutionArea[] => {
  const solutionAreas: SolutionArea[] = GetSolutionAreas();

  if (areaPathId != -1) {
    const solutionAreaMappings = GetPrivateSolutionAreaPathMappings();
    const CheckSolutionAreaIdForAreaID = solutionAreaMappings.filter(
      (x) => x.areaPathId === areaPathId
    );
    if (!CheckSolutionAreaIdForAreaID.length) {
      return solutionAreas.filter((x) => !x.isPrivate);
    }

    const soluionAreaIds = CheckSolutionAreaIdForAreaID.map((x) => x.solutionareaid.toString());
    return solutionAreas.filter((x) => soluionAreaIds.includes(x.id.toString() || ''));
  }
  return solutionAreas?.filter((x) => !x.isPrivate);
};

export const GetSolutionAreasByAreaPathByTenant = (tenant: string): SolutionArea[] => {
  void tenant;
  const solutionAreas: SolutionArea[] = GetSolutionAreas();
  const options = solutionAreas?.filter((x) => x?.tenant?.toLowerCase().includes('rob'));
  return options;
};

export const GetFyByTenant = (tenant: string): FinancialYear[] => {
  void tenant;
  const FinancialYears: FinancialYear[] = GetFinancialYearOptions();
  const options = FinancialYears?.filter((x) => x?.tenant?.toLowerCase().includes('rob'));
  return options;
};

export const GetIntakeOptions = (): IntakeType[] => GetDropdownOptions('intake');

export const GetSubStateOptions = (): SubState[] => GetDropdownOptions('subStates');

export const GetROBSubStateOptions = (): ROBSubState[] => GetDropdownOptions('rob_substate');

export const GetPriorityOptions = (): Priority[] => GetDropdownOptions('actionPriorities');

export const GetImpactTypeOptions = (): ImpactType[] => GetDropdownOptions('Rob_ImpactTypes');

export const GetSubRegionOptions = (): SubRegion[] => GetDropdownOptions('subRegion');

export const GetROBSubRegionOptions = (): ROBSubRegion[] => GetDropdownOptions('rob_Subregion');

export const GetTenantSubRegionOptions = (tenantStr: string): SubRegion[] => {
  const subRegion: SubRegion[] = GetSubRegionOptions();
  return subRegion?.filter((g) => g?.tenant && g?.tenant.includes(tenantStr));
};

export const GetCustomIndustryOptions = (): CustomIndustry[] =>
  GetDropdownOptions('customIndustries');

export const GetIndustryOptions = (): Industry[] => GetDropdownOptions('industries');

export const GetOpportunityStageOptions = (): OpportunityStage[] =>
  GetDropdownOptions('opportunityStages');

export const GetOpportunityIntentOptions = (): OpportunityIntent[] =>
  GetDropdownOptions('opportunityIntent');

export const GetMilestoneStatusOptions = (): MilestoneStatus[] =>
  GetDropdownOptions('mileStoneStatuses');

export const GetOpportunityStatusOptions = (): OpportunityStatus[] =>
  GetDropdownOptions('opportunityStatus');

export const GetHelpNeededOptions = (): HelpNeeded[] => GetDropdownOptions('helpNeededOptions');

export const GetMilestoneWorkloadOptions = (): MilestoneWorkload[] =>
  GetDropdownOptions('mileStoneWorkloads');

export const GetSuperRevSumDivisionOptions = (): SuperRevSumDivision[] =>
  GetDropdownOptions('superRevSumDivisionMappings');

export const GetSalesPlayOptions = (): SalesPlay[] => GetDropdownOptions('salesPlayMappings');

export const GetFinancialYearOptions = (): FinancialYear[] => GetDropdownOptions('fys');

export const GetQuarterOptions = (): Quarter[] => GetDropdownOptions('quarters');

export const GetTop5AskOptions = (): Top5Ask[] => GetDropdownOptions('qbcTop5Asks');

export const GetAzurePriorityOptions = (): AzurePriority[] => GetDropdownOptions('azurePriorities');

export const GetTopicCategoryOptions = (): TopicCategory[] => GetDropdownOptions('topicCategories');

export const GetWorkItemStates = (): WorkItemState[] => GetDropdownOptions('workItemStates');

export const GetROBStates = (): ROBState[] => GetDropdownOptions('rob_states');

export const GetRequestTypeOptions = (): RequestType[] => GetDropdownOptions('requestTypes');

export const GetOrgOptions = (): Organization[] => GetDropdownOptions('organization');

export const GetThemeOptions = (): Theme[] => GetDropdownOptions('themes');

export const GetDeliveryBlockers = (): DeliveryBlockers[] => GetDropdownOptions('deliveryBlockers');

export const GetEngagementCategoryOptions = (): EngagementCategory[] =>
  GetDropdownOptions('engagementCategory');

export const GetEngagementRegionOptions = (): EngagementRegion[] =>
  GetDropdownOptions('engagementRegion');

export const GetScenarioCohortOptions = (): ScenarioCohort[] =>
  GetDropdownOptions('scenarioCohort');

export const GetFirstPartyOfferingOptions = (): FirstPartyOffering[] =>
  GetDropdownOptions('firstPartyOffering');

export const GetFirstPartySolutionOptions = (): FirstPartySolution[] =>
  GetDropdownOptions('firstPartySolution');

export const GetThirdPartySolutionOptions = (): ThirdPartySolution[] =>
  GetDropdownOptions('thirdPartySolution');

export const GetSOObjectiveOptions = (): SOObjective[] => GetDropdownOptions('SOObjective');

export const GetProjectNameOptions = (): ProjectName[] => GetDropdownOptions('projectName');
export const GetBusinessDivisionOptions = (): BusinessDivision[] =>
  GetDropdownOptions('businessDivision');
export const GetIntakeTypeOptions = (): IntakeType[] => GetDropdownOptions('intake');
export const GetProblemTypeOptions = (): ProblemType[] => GetDropdownOptions('problemType');
export const GetStrategicCategoryOptions = (): StrategicCategory[] =>
  GetDropdownOptions('strategicCategory');
export const GetRolesImpactedOptions = (): RolesImpacted[] => GetDropdownOptions('rolesImpacted');
export const GetProcessOrToolsImpactedOptions = (): ToolsImpacted[] =>
  GetDropdownOptions('toolsImpacted');
export const GetL1BusinessProcessOptions = (): L1BusinessProcess[] => GetDropdownOptions('bpa_L1');
export const GetL2BusinessProcessOptions = (): L2BusinessProcess[] => GetDropdownOptions('bpa_L2');
export const GetL3BusinessProcessOptions = (): L3BusinessProcess[] => GetDropdownOptions('bpa_L3');
export const GetExecutingTeamNameOptions = (): ExecutingTeamName[] =>
  GetDropdownOptions('executingTeamName');

export function GetLogicalOperators(): LogicalOperator[] {
  return [
    { id: 0, logicalOperator: 'And' },
    { id: 1, logicalOperator: 'Or' },
  ];
}

export const GetFields = (): ADOField[] => GetDropdownOptions('fields');

export function GetSQLOperators(): SQLOperator[] {
  return [
    { id: 0, sqlOperator: '=' },
    { id: 1, sqlOperator: '<>' },
    { id: 2, sqlOperator: '>' },
    { id: 3, sqlOperator: '<' },
    { id: 4, sqlOperator: '>=' },
    { id: 5, sqlOperator: '<=' },
    { id: 6, sqlOperator: 'Contains Words' },
    { id: 7, sqlOperator: 'Does Not Contain Words' },
    { id: 8, sqlOperator: 'Contains' },
    { id: 9, sqlOperator: 'Does Not Contain' },
    { id: 10, sqlOperator: 'In' },
    { id: 11, sqlOperator: 'Not In' },
    { id: 12, sqlOperator: 'In Group' },
    { id: 13, sqlOperator: 'Not In Group' },
    { id: 14, sqlOperator: 'Was Ever' },
    { id: 15, sqlOperator: 'Is Empty' },
    { id: 16, sqlOperator: 'Is Not Empty' },
    { id: 17, sqlOperator: 'Under' },
    { id: 18, sqlOperator: 'Not Under' },
  ];
}

export function GetFieldValues(): FieldValue[] {
  return [{ id: 0, fieldValueName: 'Select' }];
}

export const GetIntentToMoveTocloud = (): IntentToMoveToCloud[] =>
  GetDropdownOptions('intentToMoveToCloud');

export const GetInterestedInOtherECIF = (): InterestedInOtherECIF[] =>
  GetDropdownOptions('interestedInOtherECIF');

export const GetIfNoStateReason = (): IfNoStateReason[] => GetDropdownOptions('ifNoStateReasons');

export const GetIfYesStateReason = (): IfYesStateReason[] => GetDropdownOptions('ifYesStateReason');

export const GetPrograms = (): Program[] => GetDropdownOptions('programs');

export const GetStatus = (): ADOStatus[] => GetDropdownOptions('statuses');

export const GetApplication = (): Application[] => GetDropdownOptions('application');

export const GetEcifStatus = (): EcifStatus[] => GetDropdownOptions('ecifStatus');

export const GetRequestedServiceStatus = (): EcifRequestedServiceStatus[] =>
  GetDropdownOptions('ecifRequestedServiceStatus');

export const GetInterestInAssessment = (): InterestInAssessment[] =>
  GetDropdownOptions('interestedInAssessment');

export const GetAssesmentType = (): AssesmentType[] => GetDropdownOptions('assessmentType');

export const GetMigrationType = (): MigrationType[] => GetDropdownOptions('migrationTypes');

export const GetPatner = (): Patner[] => GetDropdownOptions('partner');

export const GetEcifStatusIfCma = (): EcifStatusIfCma[] => GetDropdownOptions('ecifStatusIfCMA');

export const GetEcifStatusIfFam = (): EcifStatusIfFam[] => GetDropdownOptions('ecifStatusForFAM');

export const GetInterestedInRenewing = (): InterestedInRenewing[] =>
  GetDropdownOptions('interestedInRenewing');

export const GetAssesmentServiceStatus = (): AssesmentServiceStatus[] =>
  GetDropdownOptions('assessmentServiceStatus');

export const GetMilestoneReason = (): MilestoneReason[] => GetDropdownOptions('milestoneReasons');

export const GetReferralOpportunityKeyword = (): ReferralOpportunityKeyword[] =>
  GetDropdownOptions('ReferralOpportunityKeyword');

export const GetReferralDeDupSubSegmentList = (): ReferralDeDupSubSegmentList[] =>
  GetDropdownOptions('ReferralDeDupSubSegmentList');

export function GetNonRecurringValues(): NonRecurringValues[] {
  return [
    { id: 1, value: 'Yes', nonRecurring: 'Yes' },
    { id: 2, value: 'No', nonRecurring: 'No' },
  ];
}

export const GetFeedbackTypeOptions = (): FeedbackType[] => GetDropdownOptions('feedbackTypes');

export const GetTriageValues = (): Triage[] => GetDropdownOptions('triage');

export const GetTestSuitType = (): TestSuitType[] => GetDropdownOptions('testSuitType');

export const GetAutomationStatus = (): AutomationStatus[] => GetDropdownOptions('automationStatus');

export const GetValueArea = (): ValueArea[] => GetDropdownOptions('valueArea');

export const GetRating = (): Rating[] => GetDropdownOptions('rating');

export const GetWorkItemType = (): WorkItemType[] => GetDropdownOptions('workItemType');

export const GetSeverity = (): Severity[] => GetDropdownOptions('severity');

export const GetClosedStatus = (): ClosedStatus[] => GetDropdownOptions('closedStatus');

export const GetClosedStatusCode = (): ClosedStatusCode[] => GetDropdownOptions('closedStatusCode');

export const GetStateCode = (): StateCode[] => GetDropdownOptions('stateCode');

export const GetCloudIntentreason = (): CloudIntentreason[] =>
  GetDropdownOptions('cloudIntentreason');

export const GetActivity = (): Activity[] => GetDropdownOptions('activity');

export const GetNonRenewingReason = (): NonRenewingReason[] =>
  GetDropdownOptions('nonRenewingReason');

export const GetIssue = (): Issue[] => GetDropdownOptions('issue');

export const GetIntegrationBuild = (): IntegrationBuild[] => GetDropdownOptions('integrationBuild');

export const GetFoundIn = (): FoundIn[] => GetDropdownOptions('foundIn');

export const GetAssistedMigrationreason = (): AssistedMigrationreason[] =>
  GetDropdownOptions('assistedMigrationReason');

export const GetIsAssistedMigrationAnOption = (): IsAssistedMigrationAnOption[] =>
  GetDropdownOptions('isAssistedMigrationAnOption');

export const GetAssociatedType = (): AssociatedContextType[] =>
  GetDropdownOptions('associatedContextType');

export const GetActionOptions = (): ActionOption[] => GetDropdownOptions('actionOption');

export const GetBoardColumn = (): BoardColumn[] => GetDropdownOptions('boardColumn');

export const GetScopeOldOptions = (): ScopeOld[] => GetDropdownOptions('scopeOld');

export const GetEngineeringContactValues = (): EngineeringContacts[] =>
  GetDropdownOptions('engineeringContacts');

export const GetEngineeringStatus = (): EngineeringStatus[] =>
  GetDropdownOptions('engineeringStatus');

export const GetHelpNeededOpportunityOptions = (): HelpNeededOpportunity[] =>
  GetDropdownOptions('helpNeededOpportunityOptions');

export function GetReason(): Reason[] {
  return [
    { id: 0, reason: 'Select Tag' },
    { id: 1, reason: 'Value 1' },
    { id: 2, reason: 'Value 2' },
  ];
}

export const GetHelpNeededApexOptions = (): HelpNeededApex[] =>
  GetDropdownOptions('helpNeededApexOptions');

export const GetCustomerEngagementActivityOptions = (): CustomerEngagementActivity[] =>
  GetDropdownOptions('customerEngagementActivityOptions');

export const GetCollabAppsContestOptions = (): CollabAppsContest[] =>
  GetDropdownOptions('collabAppsContestOptions');

export const GetReferredToOptions = (): ReferredTo[] => GetDropdownOptions('referredToOptions');

export const GetActionCategories = (): ActionCategory[] => GetDropdownOptions('actionCategories');

export const GetROBActionCategories = (): RobActionCategory[] =>
  GetDropdownOptions('robActionCategory');

export const GetTypeOfFunds = (): TypeOfFunds[] => GetDropdownOptions('eciffundtype');

export const GetProgramName = (): ECIFProgram[] => GetDropdownOptions('ecifprogramName');

export const GetActivityTypes = (): EcifActivityType[] => GetDropdownOptions('ecifActivityType');

export const GetMSXAOAIWorkloads = (): MSXAOAIWorkloads[] => GetDropdownOptions('msxAOAIWorkloads');

export const GetRaidPriority = (): RaidPriority[] => GetDropdownOptions('raidPriority');

export const GetRaidStatus = (): RaidStatus[] => GetDropdownOptions('raidStates');

export const GetPatternGroup = (): PatternGroup[] => GetDropdownOptions('patternGroup');

export const GetIterationPath = (): IterationPath[] => GetDropdownOptions('iterationPath');

export const GetTrueFalse = (): TrueFalse[] => GetDropdownOptions('trueFalse');

export const GetCompletionStatusIfCombined = (): CompleationStatusIfCombined[] =>
  GetDropdownOptions('completionStatusIfcombined');

export const GetMeetingTypeOrigin = (): MeetingTypeOrigin[] =>
  GetDropdownOptions('meetingTypeOrigins');

export const GetTypeofFundsByValue = (selectedFundType: string): TypeOfFunds[] => {
  const typeofFunds: TypeOfFunds[] = GetTypeOfFunds();
  return typeofFunds.filter((g) => g?.fundtype === selectedFundType);
};
export const GetSolutionAreaByValue = (selectedSolutionArea: string): SolutionArea[] => {
  const solutionAreas: SolutionArea[] = GetSolutionAreas();
  return solutionAreas?.filter((x) => x?.solutionArea === selectedSolutionArea);
};

export const GetMeetingTypeOriginByAreaPath = (areaPathId: number): MeetingTypeOrigin[] => {
  const meetingTypes: MeetingTypeOrigin[] = GetDropdownOptions('meetingTypeOrigins');
  //If there is no areapath mapping specified, get all the meeting types which are not private
  if (areaPathId != -1) {
    //If there are specific meetingtypes to be shown w.r.t areapath, then get meetingtypes w.r.t areapath from GetPrivateMeetingTypeAreaPathMapping table
    const meetingTypeMappings = GetPrivateMeetingTypeAreaPathMapping();
    const CheckmeetingtypeIdForAreaID = meetingTypeMappings.filter(
      (x) => x.areaPathId === areaPathId
    );
    if (!CheckmeetingtypeIdForAreaID.length) {
      return meetingTypes.filter((x) => !x.isPrivate);
    }
    const meetingTypeIds = CheckmeetingtypeIdForAreaID.map((x) => x.meetingTypeId.toString());
    return meetingTypes.filter((x) => meetingTypeIds.includes(x.id.toString() || ''));
  }
  return meetingTypes.filter((x) => !x.isPrivate);
};

export const GetPrivateMeetingTypeAreaPathMapping = (): PrivateMeetingTypeAreaPathMapping[] =>
  GetDropdownOptions('privateMeetingTypeAreaPathMapping');

export const GetOperatingUnit = (): OperatingUnit[] => GetDropdownOptions('operatingUnit');
export const GetCloudImpacted = (): CloudImpacted[] => GetDropdownOptions('cloudImpacted');
export const GetMeetingSubTypes = (): MeetingSubType[] => GetDropdownOptions('meetingSubTypes');

export const GetSMCCSegments = (): SMCCSegment[] => GetDropdownOptions('Smcc_Segments');
export const GetSMCCSubSegments = (): SMCCSubSegment[] => GetDropdownOptions('Smcc_SubSegments');
export const GetSMCCSRouteMappingDetails = (): SMCCRouteMapping[] =>
  GetDropdownOptions('Smcc_RouteMapping');
export const GetSMCCSubSegmentID = (smccSubSegment: string): SMCCSubSegment[] => {
  const smccSubSegments = GetSMCCSubSegments();
  return smccSubSegments?.filter((g) => g.smccSubSegments === smccSubSegment);
};
export const GetSMCCSegmentID = (smccSegment: string): SMCCSegment[] => {
  const smccSubSegments = GetSMCCSegments();
  return smccSubSegments.filter((g) => g.smccSegments === smccSegment);
};
export const GetSMCCMeetingTypeOrigin = (tenant: string): MeetingTypeOrigin[] => {
  const meetingTypeOrigins: MeetingTypeOrigin[] = GetDropdownOptions('meetingTypeOrigins');
  return meetingTypeOrigins.filter((g) => g.tenant === tenant);
};
export const GetSMCCMeetingTypeOriginByValue = (
  tenant: string,
  meetingType: string
): MeetingTypeOrigin[] => {
  const meetingTypeOrigins: MeetingTypeOrigin[] = GetDropdownOptions('meetingTypeOrigins');
  return meetingTypeOrigins.filter(
    (g) => g.tenant === tenant && g.meetingTypeOrigin === meetingType
  );
};
export const GetSMCCRouteMapping = (
  meetingTypeId: number,
  segmentId: number,
  subSegmentId: number,
  areaId: number,
  assignToCorp: string
): SMCCRouteMapping[] => {
  const smccRouteMapping: SMCCRouteMapping[] = GetSMCCSRouteMappingDetails();
  return smccRouteMapping.filter(
    (g) =>
      g.meetingTypeID === meetingTypeId &&
      g.smcc_SegmentID === segmentId &&
      g.smcc_SubSegmentID === subSegmentId &&
      g.areaID.includes(areaId?.toString()) &&
      g.assigntoCorp === assignToCorp
  );
};

export const GetEmailNotificationTemplates = (): EmailNotificationTemplates[] =>
  GetDropdownOptions('EmailNotificationTemplates');
export const GetCoSellRequestCategoryDetails = (requestCategory: string): CoSellRequestCategory[] => {
  const coSellRequestCategoryDetails: CoSellRequestCategory[] = GetCoSellRequestCategory();
  return coSellRequestCategoryDetails.filter((g) => g.requestCategory === requestCategory);
};
export const GetCoSellSubCategoryTopicDetails = (subCategoryTopic: string): CoSellSubCategoryTopic[] => {
  const coSellSubCategoryTopicDetails: CoSellSubCategoryTopic[] = GetCoSellSubCategoryTopic();
  return coSellSubCategoryTopicDetails.filter((g) => g.subCategoryTopic === subCategoryTopic);
};
export const GetEmailNotificationTemplatesDetails = (
  tenant: string,
  requestCategory: string,
  subCategoryTopic: string
): EmailNotificationTemplates[] => {
  const emailNotificationTemplatesDetails: EmailNotificationTemplates[] =
    GetEmailNotificationTemplates();
  if (tenant === UATConstants.PlaceholdersAndTitles.CoSell) {
    const requestCategoryInfo = GetCoSellRequestCategoryDetails(requestCategory);
    const subCategoryTopicInfo = GetCoSellSubCategoryTopicDetails(subCategoryTopic);

    const requestCategoryID =
      requestCategoryInfo.length > 0 ? requestCategoryInfo[0]?.id?.toString() : '';
    const subCategoryTopicID =
      subCategoryTopicInfo.length > 0 ? subCategoryTopicInfo[0]?.id?.toString() : '';

    if (!requestCategoryID || !subCategoryTopicID) {
      return [];
    }
    return emailNotificationTemplatesDetails?.filter(
      (g) =>
        g.SubCategoryTopicID?.split(',').includes(subCategoryTopicID) &&
        g.RequestCategoryID?.split(',').includes(requestCategoryID) &&
        g.Status === '1' &&
        g.Tenant === tenant
    );
  } else if(UATConstants.PlaceholdersAndTitles.RegionalSkilling === tenant){
    return emailNotificationTemplatesDetails.filter((g) => tenant.includes(g.Tenant) && g.Status === '1');
  }
   else { 
    return emailNotificationTemplatesDetails.filter((g) => g.Tenant === tenant && g.Status === '1');
  }
};

export function GetAreaPathIdByID(areaId: number): AreaPath {
  const areaOptions = GetAreaPaths();
  return areaOptions.filter((g) => g.id === areaId)[0];
}
export function GetAreaIdByName(area: string): Area {
  const areaOptions = GetAreas();
  return areaOptions.filter((g) => g.area === area)[0];
}
export const GetMeetingTypesById = (meetingId: number): MeetingSubType[] => {
  const meetingSubTypes = GetMeetingSubTypes();
  return meetingSubTypes.filter((g) => g.meetingTypeId === meetingId);
};
export const GetWorkloadType = (): WorkloadType[] => GetDropdownOptions('workloadType');
// Get Fields in Column Optoins panel dropdown
export const GetColumnOptionsFields = (): ADOColumnNames[] =>
  GetDropdownOptions('displayColumnOptions');

export const GetAdditionalTheme = (): AdditionalTheme[] => GetDropdownOptions('additionalThemes');

//added new values for ignored Fields
export const GetDateValues = (): DateDropDown[] => GetDropdownOptions('dateSelectionFormat');

export function GetAssignedToCorpValues(): AssignedToCorpValues[] {
  return [
    { id: 1, value: true, assignToCorp: 'Yes' },
    { id: 2, value: false, assignToCorp: 'No' },
  ];
}

export function GetDeliveryMethodValues(): DeliveryMethodValues[] {
  return [
    { id: 1, value: 'Consulting', deliveryMethod: 'Consulting' },
    { id: 2, value: 'Partner', deliveryMethod: 'Partner' },
    { id: 3, value: 'Support', deliveryMethod: 'Support' },
  ];
}
// EntityTypeValues
export function GetEntityTypeValues(): EntityTypeValues[] {
  return [
    { id: 1, value: 'Public Sector', entityType: 'Public Sector' },
    {
      id: 2,
      value: 'State Owned Entity',
      entityType: 'State Owned Entity',
    },
    { id: 3, value: 'Commercial', entityType: 'Commercial' },
  ];
}

export function GetNominationTypeValues(): NominationTypeValues[] {
  return [
    { id: 1, value: 'Customer Hub', nominationType: 'Customer Hub' },
    //{ id: 2, value: "Customer Hub", nominationType: "Activation Hub" },
  ];
}

export function GetIdInValues(): IdInValue[] {
  return [{ id: 1, valueIn: '@Follows' }];
}

export const GetMigrationServiveStatusOptions = (): MigrationServiceStatus[] =>
  GetDropdownOptions('migrationServiceStatus');

export const GetActionType = (): ActionType[] => GetDropdownOptions('actionType');

export const GetInterestedAssistedMigrationreason = (): InterestedAssistedMigrationreason[] =>
  GetDropdownOptions('interestedAssistedMigrationreason');

export const GetServiceTreeOffering = (): ServiceTreeOffering[] =>
  GetDropdownOptions('serviceTreeOffering');

export const GetServiceTreeOffering2 = (): ServiceTreeOffering[] =>
  GetDropdownOptions('serviceTreeOffering2');

export const GetServiceTreeOffering3 = (): ServiceTreeOffering[] =>
  GetDropdownOptions('serviceTreeOffering3');

export const GetApplicationType = (): ApplicationType[] => GetDropdownOptions('applicationType');

export const GetYesOrNo = (): YesOrNo[] => GetDropdownOptions('yesOrNo');

export const GetRequestTypeValues = (): RequestTypeValues[] =>
  GetDropdownOptions('aoaiRequestType');

export const GetRequestUrgencyValues = (): RequestUrgencyValues[] =>
  GetDropdownOptions('request_urgency');

export const GetUOMValues = (): UOMValues[] =>
  GetDropdownOptions('aoai_uom');

export const GetBlockerTypeValues = (): BlockerTypeValues[] => GetDropdownOptions('blockerType');

export const GetCustomerPriorityValues = (): CustomerPriorityValues[] =>
  GetDropdownOptions('customerPriority');

export const GetDealTypeValues = (): DealTypeValues[] => GetDropdownOptions('aoaiDealType');

export const GetRequestVMsTypeValues = (): RequestVMsTypeValues[] =>
  GetDropdownOptions('aoaiRequestedVMType');

export const GetRegionFlexibilityValues = (): RequestRegionFlexibilityTypeValues[] =>
  GetDropdownOptions('aoaiRegionFlexibility');

export const GetNonGpuAcrValues = (): RequestNonGpuAcrTypeValues[] =>
  GetDropdownOptions('aoaiNonGpuAcr');

export const GetDeploymentFrequencyValues = (): RequestDeploymentFrequencyValues[] =>
  GetDropdownOptions('aoaiDeploymentFrequency');

export const GetLLMOrLMMValues = (): RequestLLMOrLMMValues[] => GetDropdownOptions('aoaiLLMOrLMM');

export const GetInterconnectedClusterValues = (): RequestInterconnectedClusterValues[] =>
  GetDropdownOptions('aoaiInterconnectedCluster');

export const GetIscustomerneedvalidatedforNCseriesValues =
  (): RequestIscustomerneedvalidatedforNCseriesValues[] =>
    GetDropdownOptions('aoaiIscustomerneedvalidatedforNCseries');

export const GetDwrRecommendationValues = (): RequestDwrRecommendationValues[] =>
  GetDropdownOptions('aoaiDwrRecommendation');

export const GetValidatedbyAIgbbsValues = (): RequestValidatedbyAIgbbsValues[] =>
  GetDropdownOptions('aoaiValidatedbyAIgbbs');

export const GetMainUseCategoriesValues = (): RequestMainUseCategoriesValues[] =>
  GetDropdownOptions('aoaiMainUseCategories');

export const GetPreferredRegionValues = (): PreferredRegionValues[] =>
  GetDropdownOptions('aoaiPreferredRegion');

export const getRequestedRegionValues = (): RequestedRegionValues[] =>
  GetDropdownOptions('aoaiRequestedRegion');

export const GetNonAISKUValues = (): NonAISKUValues[] => GetDropdownOptions('NoNAI_SKU');
// export const GetNonAISKUValues = (): NonAISKUValues[] => NoNAISKU_list;

export const GetNonAIRequestTypeValues = (): NonAIRequestTypeValues[] =>
  GetDropdownOptions('NoNAI_RequestType');

export const GetNonAIRegionalZonalValues = (): NonAIRegionalZonalValues[] =>
  GetDropdownOptions('NoNAI_Regional_Zonal');

export const GetNonAIUOMValues = (): NonAIUOMValues[] => GetDropdownOptions('NoNAI_UOM');

export const GetNonAIWorkloadImpactValues = (): NonAIWorkloadImpactValues[] =>
  GetDropdownOptions('NoNAI_Workload_Impact');

export const GetNonAIV6SKUValues = (): NonAIV6SKUValues[] =>
  GetDropdownOptions('NoNAI_V6_SKU');

export const GetNonAIActionOwnerMappingValues = (): NonAIActionOwnerMappingValues[] =>
  GetDropdownOptions('NoNAI_ActionOwnerMapping');

export const GetModelValues = (): ModelValues[] => GetDropdownOptions('aoaiModel');

export const GetActiveModelValues = (): ModelValues[] =>
  GetModelValues().filter((model) => {
    if (!model.allowedtoDisplay?.trim()) {
      return true;
    }

    return model.allowedtoDisplay
      .split(',')
      .some((code) => code.trim().toUpperCase() === 'C');
  });

export const GetTimezoneValues = (): TimeZoneValues[] => GetDropdownOptions('aoaiTimezone');

export const GetDecisionValues = (): DecisionValues[] => GetDropdownOptions('aoaiDecision');

export function GetModelValuesById(AOAIRequestTypeID: string): ModelValues[] {
  const model = GetModelValues();
  return model.filter((g) => g.AOAI_RequestTypeID?.includes(AOAIRequestTypeID));
}

export function GetRequestypeValuesByText(AOAIRequestType: string): RequestTypeValues[] {
  const requestTypes = GetRequestTypeValues();
  return requestTypes.filter((g) => g.requestType?.toString() === AOAIRequestType);
}

export function GetAreaById(area: string): Area[] {
  const areas = GetAreas();
  return areas.filter((g) => g.area === area);
}

export function GetTimeZoneId(id: number): TimeZoneValues[] {
  const timzones = GetTimezoneValues();
  return timzones.filter((g) => g.id == id);
}

export function GetPreferredRegionId(id: string): PreferredRegionValues[] {
  const preferred = GetPreferredRegionValues();
  return preferred.filter((g) => g.id.toString() == id);
}
export const GetMaaSRoleOptions = (): MaaS_Role[] => GetDropdownOptions('MaaS_Role');
export const GetCloudVsOnpremOptions = (): RB_InfraLocation[] =>
  GetDropdownOptions('rbInfraLocation');
export const GetMaaSOUOptions = (): MaaS_OU[] => GetDropdownOptions('MaaS_OU');
export const GetMaaSSubSegementOptions = (): MaaS_SubSegment[] =>
  GetDropdownOptions('MaaS_SubSegment');
export const GetMaaSMCEMOptions = (): MaaS_MCEM[] => GetDropdownOptions('MaaS_MCEM');
export const GetMaaSIndustryOptions = (): MaaS_Industry[] => GetDropdownOptions('MaaS_Industry');
export const GetMaaSSegmentOptions = (): MaaS_Segment[] => GetDropdownOptions('MaaS_Segment');
export const GetSegmentOptions = (): Segment[] => GetDropdownOptions('rob_Segments');
export const GetMaaSSubRoleOptions = (): MaaS_SubRole[] => GetDropdownOptions('MaaS_SubRole');
export const GetMaasSpecificCountryOptions = (): MaaS_SpecificCountry[] =>
  GetDropdownOptions('MaaS_SpecificCountry');
export const GetMaaSSubRoleOptionsByRole = (role: string): MaaS_SubRole[] => {
  const subrole = GetMaaSSubRoleOptions();
  let roleid = 0;
  role == 'Marketer' ? (roleid = 1) : role == 'Seller' ? (roleid = 2) : (roleid = 0);
  return subrole?.filter((g) => g.RoleId == roleid);
};
export const GetMaaSRequestTypeOptions = (): MaaS_RequestTypes[] =>
  GetDropdownOptions('MaaS_RequestType');
export const GetMaaSEventTypeOptions = (): MaaS_EventTypes[] =>
  GetDropdownOptions('MaaS_EventType');
export const GetMaaSMarketingPlayOptions = (): MaaS_EventTypes[] =>
  GetDropdownOptions('MaaS_MarketingPlay');
export const GetMaaSLeadSourceTypeOptions = (): MaaS_EventTypes[] =>
  GetDropdownOptions('MaaS_LeadSourceType');
export function GetMaaSMaaSIsExistingAccOptions(): MaaS_IsExistingAccount[] {
  return [
    { id: 1, option: 'No - New account' },
    { id: 2, option: 'Update Existing Account' },
  ];
}
export const GetMaaSExistingAccountValues = (): MaaS_ExistingAccountValues[] =>
  GetDropdownOptions('MaaS_ExistingAccountValues');

export const GetMaaSAreaOptions = (): MaaS_Area[] => GetDropdownOptions('MaaS_Area');

export const GetGeneralCategoryOptions = (): RB_GeneralCategory[] =>
  GetDropdownOptions('rbGeneralCategory');

export const GetTicketReasonOptions = (): RB_TicketReason[] => GetDropdownOptions('rbTicketReason');

export const GetRBAreaOptions = (): RB_Area[] => GetDropdownOptions('rbArea');

export const GetRegionOptions = (): RB_Region[] => GetDropdownOptions('rbRegion');

export const GetROBRegionOptions = (): Region[] => GetDropdownOptions('region');

export const GetCountryOptions = (): RB_Country[] => GetDropdownOptions('rbCountry');
export const GetLanguageOptions = (): Language[] => GetDropdownOptions('languages');

export const GetReasonForExceptionOptions = (): MACC_Reason_for_Exceptions[] =>
  GetDropdownOptions('maccReasonforException');

export const GetReasonForExceptionOptionsForMDC = (): MDC_Reason_for_Exceptions[] =>
  GetDropdownOptions('deF_Exception');

export const GetTechnologyOptions = (): RB_Technology[] => GetDropdownOptions('rbTechnology');

export const GetRBTierOptions = (): RB_Tier[] => GetDropdownOptions('rbTier');

export function GetMeetingSubTypeId(value: string): MeetingType[] {
  const meetingType = GetMeetingTypeOrigin();
  return meetingType.filter((g) => g.meetingTypeOrigin == value);
}

export const GetGSI_BudgetProgram = () => GetDropdownOptions<{ gsiBudgetProgram: string }>('GSI_BudgetProgram');
export const GetGSI_PartnerType = () => GetDropdownOptions<{ gsiPartnerType: string }>('GSI_PartnerType');
export const GetGSI_RequestReason = () => GetDropdownOptions<{ gsiRequestReason: string }>('GSI_RequestReason');
export const GetGSI_DealStructure = () => GetDropdownOptions<{ gsiDealStructure: string }>('GSI_DealStructure');
export const GetGSI_LicensingProgram = () => GetDropdownOptions<{ gsiLicensingProgram: string }>('GSI_LicensingProgram');
export const GetGSI_State = () => GetDropdownOptions<{ id: number; gsiState: string }>('GSI_State');
export const GetGSI_SubState = (): any => GetDropdownOptions('GSI_SubState');

// Get Co-Marketing dropdown values
export const GetPMYTSourceOfInvestment = (): PMYTSourceOfInvestment[] =>
  GetDropdownOptions('PMYT_SourceOfInvestment');

export const GetPMYTSolutionPlays = () => GetDropdownOptions<{ pmytSolutionPlay: string }>('PMYT_SolutionPlay');

export const GetPMYTArea = () => GetDropdownOptions<{ pmytArea: string }>('PMYT_Area');

export const GetPMYTIndustry = () => GetDropdownOptions<{ pmytIndustry: string }>('PMYT_Industry');

export const GetPMYT_CustomerSegment = () => GetDropdownOptions<{ pmytCustomerSegment: string }>('PMYT_CustomerSegment');

export const GetPMYT_PartnerType = () => GetDropdownOptions<{ pmytPartnerType: string }>('PMYT_PartnerType');

export const GetPMYT_ApproverList = (): PMYTApprover[] => GetDropdownOptions('PMYT_ApproverList');

export const GetPMYT_SGList = (): PMYTSG[] => GetDropdownOptions('PMYT_SGList');

export const GetPMYT_SGApproverMappingList = (): PMYTSGApproverMapping[] =>
  GetDropdownOptions('PMYT_SGApproverMappingList');

export const GetCoSellSubCategoryTopic = (): CoSellSubCategoryTopic[] =>
  GetDropdownOptions('CoSellSubCategoryTopic');
export const GetCoSellActivity = (): CoSellActivity[] => GetDropdownOptions('CoSellActivity');
export const GetCoSellBusinessRulesHelper = (): CoSellBusinessRulesHelper[] =>
  GetDropdownOptions('CoSellBusinessRulesHelper');
export const GetCoSellRequestCategory = (): CoSellRequestCategory[] => GetDropdownOptions('CoSellRequestCategory');
export const GetCoSellPartnerRegion = (): CoSellPartnerRegion[] =>
  GetDropdownOptions('CoSellPartnerRegion');
export const GetCoSellPartnerCountry = (): CoSellPartnerCountry[] =>
  GetDropdownOptions('CoSellPartnerCountry');
export const GetCoSellPartnerArea = (): CoSellPartnerArea[] =>
  GetDropdownOptions('CoSellPartnerArea');
export const GetCoSellDeliveryLanguageSupport = (): CoSellDeliveryLanguageSupport[] =>
  GetDropdownOptions('CoSellDeliveryLanguageSupport');
export const GetCoSellPartnerEngaged = (): CoSellPartnerEngaged[] =>
  GetDropdownOptions('CoSellPartnerEngaged');
export const GetCoSellMCEMSalesStage = (): CoSellMCEMSalesStage[] =>
  GetDropdownOptions('CoSellMCEMSalesStage');
export const GetCoSellDealStatus = (): CoSellDealStatus[] => GetDropdownOptions('CoSellDealStatus');
export const GetCoSellRequestType = (): CoSellRequestType[] =>
  GetDropdownOptions('CoSellRequestType');
export function GetActionCategoryType(value: string): ActionCategory[] {
  const actionCategrory = GetActionCategories();
  return actionCategrory.filter((g) => g.actionCategory == value);
}

export const GetGPSRequestTypeOptions = (): GPS_RequestType[] => {
  return GetDropdownOptions('GPS_RequestType');
};
export const GetStageOptions = (): GPS_Stage[] => GetDropdownOptions('GPS_Stage');

export const GetGPSDiscussionOptions = (): GPS_DiscussionType[] =>
  GetDropdownOptions('GPS_DiscussionType');

export const GetGPSBusinessOptions = (): GPS_Business[] => GetDropdownOptions('GPS_Business');

export const GetGPSProductOptions = (): GPS_Product[] => GetDropdownOptions('GPS_Product');

export const GetGPSAskTypeOptions = (): GPS_AskType[] => GetDropdownOptions('GPS_AskType');

export const GetGPSCustomerSegmentOptions = (): GPS_CustomerSegment[] =>
  GetDropdownOptions('GPS_CustomerSegment');

export const GetGPSPartnerOptions = (): GPS_Partner_Type[] => GetDropdownOptions('GPS_PartnerType');

export const GetGPSCalcPartnerTypeOptions = (): GPS_Calc_Partner_Type[] => GetDropdownOptions('GPS_Calc_PartnerType');

export const GetGPSInvestmentTypeOptions = (): GPS_InvestmentType[] =>
  GetDropdownOptions('GPS_InvestmentType');

export const GetGPSSurveyUrgencyOptions = (): GPS_SurveyOption[] =>
  GetDropdownOptions<{ id: number; gpsSurveyUrgency: string }>('GPS_SurveyUrgency').map(
    ({ id, gpsSurveyUrgency }) => ({
      id,
      value: gpsSurveyUrgency,
    })
  );

export const GetGPSSurveyTypeOptions = (): GPS_SurveyOption[] =>
  GetDropdownOptions<{ gpsSurveyType: string }>('GPS_SurveyType').map(({ gpsSurveyType }) => ({
    value: gpsSurveyType,
  }));

export const GetGPSSurveyAudienceOptions = (): GPS_SurveyOption[] =>
  GetDropdownOptions<{ gpsSurveyAudience: string }>('GPS_SurveyAudience').map(({ gpsSurveyAudience }) => ({
    value: gpsSurveyAudience,
  }));

export const GetGPSLocalizedContentLibraryOptions = (): GPS_SurveyOption[] =>
  GetDropdownOptions<{ gpsLocalizedContentLibrary: string }>('GPS_LocalizedContentLibrary').map(
    ({ gpsLocalizedContentLibrary }) => ({
      value: gpsLocalizedContentLibrary,
    })
  );

export const GetGPSControlTypesOptions = (): GPS_Control_Type[] =>
  GetDropdownOptions('GPS_ControlType');

export const GetGPSPIRDecisionOptions = (): GPS_PIRDecision[] =>
  GetDropdownOptions('GPS_PIRDecision');

export const GetGPSFundingTypeOptions = (): GPS_Funding[] => GetDropdownOptions('GPS_FundingType');

export const GetGPSFundingSourceOptions = (): GPS_FundingSource[] =>
  GetDropdownOptions('GPS_FundingSource');

export const GPSInvestmentComplexity = (): GPS_InvestmentComplexity[] =>
  GetDropdownOptions('GPS_InvestmentComplexity');

export const GPSAreas = (): GPS_Areas[] => GetDropdownOptions('GPS_Area');

export const GPSEngagementType = (): GPS_EngagementType[] =>
  GetDropdownOptions('GPS_EngagementType');

export const GPSPayoutType = (): GPS_PayoutType[] => GetDropdownOptions('GPS_PayoutType');

export const GetMCEMStageOptions = (): GPS_MCEM_Stage[] => GetDropdownOptions('GPS_MCEMStages');

export const GPSChangeRequestType = (): GPS_ChangeRequestType[] =>
  GetDropdownOptions('GPS_ChangeRequestType');

export const GetGPSPaymentProgramOptions = (): GPS_PaymentProgram[] => GetDropdownOptions('GPS_PaymentProgram');

export const GetGPSEarningTypeOptions = (): GPS_EarningType[] => GetDropdownOptions('GPS_EarningType');

export const GetGPSPaymentMethodOptions = (): GPS_PaymentMethod[] => GetDropdownOptions('GPS_PaymentMethod');

export const GetGPSTCTypeOptions = (): GPS_TCType[] => GetDropdownOptions('GPS_TCType');

export const GetGPSAccountingTreatmentOptions = (): GPS_AccountingTreatment[] =>
  GetDropdownOptions('GPS_AccountingTreatment');

export const GetGPSComplexityLevelOptions = (): GPS_ComplexityLevel[] => GetDropdownOptions('GPS_ComplexityLevel');
//AMM

export const GetAMMScopeOfWorkOptions = (): AMM_ScopeOfWork[] =>
  GetDropdownOptions('Amm_ScopeOfWork');

export const GetAMMActionTakenOptions = (): AMM_ActionTaken[] =>
  GetDropdownOptions('Amm_ActionTaken');

export const GetAMMOfferOptions = (): AMM_Offer[] => GetDropdownOptions('Amm_Offer');

export const GetAMMOfferEnginestatusOptions = (): AMM_OfferEnginestatus[] =>
  GetDropdownOptions('amm_OfferEnginestatus');

export const GetAMMCancellationReasonOptions = (): AMM_CancellationReason[] =>
  GetDropdownOptions('Amm_Cancellationreason');

export const GetAMMRejectionReasonOptions = (): AMM_RejectionReason[] =>
  GetDropdownOptions('Amm_Rejectionreason');

export const GetAMMDisqualificationReasonOptions = (): AMM_DisqualificationReason[] =>
  GetDropdownOptions('Amm_Disqualificationreason');

export const GetAMMAaofertypeOptions = (): AMM_Aaofertype[] => GetDropdownOptions('Amm_Aaofertype');

export const GetAMMPendingactionfromnOptions = (): AMM_Pendingactionfrom[] =>
  GetDropdownOptions('Amm_Pendingactionfrom');

export const GetAMMSynapseDedicatedPoolworkloadOptions = (): AMM_SynapseDedicatedPoolworkload[] =>
  GetDropdownOptions('Amm_SynapseDedicatedPoolWorkload');

export const GetAMMNextBestActionOptions = (): AMM_NextBestAction[] =>
  GetDropdownOptions('Amm_Nextbestaction');

export const GetAMMTypeOfFundingNeededOptions = (): AMM_TypeOfFundingNeeded[] =>
  GetDropdownOptions('Amm_Typeoffundingneeded');

export const GetAMMMicrosoftdefenderforcloudOptions = (): AMM_Microsoftdefenderforcloud[] =>
  GetDropdownOptions('Amm_Microsoftdefenderforcloud');

export const GetAMMPrimaryAzureVirtualMachineVmSeriesOptions =
  (): AMM_PrimaryAzureVirtualMachineVmSeries[] =>
    GetDropdownOptions('amm_PrimaryAzureVirtualMachineVmSeries');

export const GetAMMDoYouWantToRequestAcoInAdditionToEcifOptions =
  (): AMM_DoYouWantToRequestAcoInAdditionToEcif[] =>
    GetDropdownOptions('Amm_DoYouWantToRequestAcoInAdditionToEcif');


export const GetAMMDealStructureOptions = (): AMM_DealStructure[] =>
  GetDropdownOptions('Amm_dealstructure');

export const GetAMMPrimarySolutionOptions = (): AMM_PrimarySolutionPlaySupporting[] =>
  GetDropdownOptions('AMM_PrimarySolutionPlaySupporting');

export const GetAMMSupportRegionOptions = (): AMM_SupportRegion[] =>
  GetDropdownOptions('Amm_SupportRegion');

export const GetAMMProgramOptions = (): AMM_Program[] => GetDropdownOptions('Amm_program');

export const GetAMMSupportedScenarioOptions = (): AMM_SupportedScenario[] =>
  GetDropdownOptions('Amm_SupportedScenario');

export const GetAMMMigrationPartnerAttachedOptions = (): AMM_MigrationPartnerAttached[] =>
  GetDropdownOptions('Amm_Migrationpartnerattached');

export const GetAMMWillThisRequestRequireAdditionalAttendeesOptions =
  (): AMM_WillThisRequestRequireAdditionalAttendees[] =>
    GetDropdownOptions('Amm_WillThisRequestRequireAdditionalAttendees');

export const GetAMMRequestTypeOptions = (): AMM_RequestType[] =>
  GetDropdownOptions('Amm_RequestType');

export const GetAMMEsiOptions = (): AMM_Esi[] => GetDropdownOptions('Amm_Esi');

export const GetAMMFtaOptions = (): AMM_Fta[] => GetDropdownOptions('Amm_Fta');

export const GetAMMCommunicationPreferenceOptions = (): AMM_CommunicationPreference[] =>
  GetDropdownOptions('Amm_Communicationpreference');

export const GetAMMHelpTypeOptions = (): AMM_HelpType[] => GetDropdownOptions('AMM_HelpType');

export const GetAMMPreOrPostOptions = (): AMM_PreOrPost[] => GetDropdownOptions('Amm_PreOrPost');

export const GetAMMCustomerCommitmentToStartOptions = (): AMM_CustomerCommitment[] =>
  GetDropdownOptions('Amm_CustomerCommitment');

export function GetAMMYesOrNoOptions(): AMM_YesOrNo[] {
  return [
    { id: 1, value: 'Yes' },
    { id: 2, value: 'No' },
  ];
}

export const GetAMMRequestReasonOptions = (): AMM_RequestReason[] =>
  GetDropdownOptions('AMM_RequestReason');

export const GetAMMAzureFutureGrowthOfferOptions = (): AMM_AzureFutureGrowthOffer[] =>
  GetDropdownOptions('AMM_AzureFutureGrowthOffer');

export const GetAMMServiceLocationOptions = (): AMM_ServiceLocation[] =>
  GetDropdownOptions('AMM_ServiceLocation');

export const GetAMMFinacialYearOptions = (): AMM_FinancialYear[] =>
  GetDropdownOptions('AMM_FinancialYear');

export const GetAMMSAPOfferOptions = (): AMM_SapOffer[] => GetDropdownOptions('AMM_SapOffer');

export const GetAMMAvsOfferRequestOptions = (): AMM_AvsOfferRequestCorrespond[] =>
  GetDropdownOptions('AMM_AvsOfferRequestCorrespond');

export const GetAMMECIFFutureGrowthOfferOptions = (): AMM_ECIFFutureGrowthOffer[] =>
  GetDropdownOptions('AMM_ECIFFutureGrowthOffer');

export const GetPrimaryAzureVirtualMachineOptions = (): Amm_primaryazurevirtualmachinevmseries[] =>
  GetDropdownOptions('Amm_primaryazurevirtualmachinevmseries');
export const GetAMMOfferEngineTypeOptions = (): AMM_OfferEngineType[] =>
  GetDropdownOptions('AMM_OfferEngineType');
export const GetAMMOfferDeskRegionOptions = (): AMM_OfferDeskRegion[] =>
  GetDropdownOptions('AMM_OfferDeskRegion');

export const GetAMMWorkItemStates = (): WorkItemState[] => GetDropdownOptions('Amm_WorkItemState');
export const GetAMMServiceOptions = (): AMM_Service[] => GetDropdownOptions('AMM_Service');
export const GetAMMSipartnersOptions = (): AMM_SIpartners[] => GetDropdownOptions('AMM_SIpartners');
export const GetAMMPlatformOptions = (): AMM_Platform[] => GetDropdownOptions('AMM_Platform');
export const GetAMMSMEDecisionOptions = (): AMM_SMEDecision[] =>
  GetDropdownOptions('AMM_SMEDecision');
export const GetAMMCompeteScenarioOptions = (): AMM_CompeteScenario[] =>
  GetDropdownOptions('AMM_CompeteScenario');
export const GetAMMAnticipatedDeliveryMethodOptions = (): AMM_AnticipatedDeliveryMethod[] =>
  GetDropdownOptions('AMM_AnticipatedDeliveryMethod');
export const GetAMMAccountTeamAlignmentOptions = (): AMM_AccountTeamAlignment[] =>
  GetDropdownOptions('AMM_AccountTeamAlignment');
export const GetAMMCustomerInterestOptions = (): AMM_CustomerInterest[] =>
  GetDropdownOptions('AMM_CustomerInterest');
export function GetAMMStateIdByName(state: string): WorkItemState {
  const stateOptions = GetAMMWorkItemStates();
  return stateOptions?.filter((g) => g.Name === state)[0];
}

export const GetAMMPartnersOptions = (): AMM_Partner[] => GetDropdownOptions('AMM_Partner');

export function GetAllWorkItemStates(): WorkItemState[] {
  const ammstateOptions = GetAMMWorkItemStates() ?? [];
  const stateOptions = GetWorkItemStates() ?? [];
  const helpstateoptions = GetAMMHelpWorkItemStates() ?? [];

  const mergedObj = [...ammstateOptions, ...stateOptions, ...helpstateoptions];
  const finalArr: WorkItemState[] = [];
  for (let i = 0; i < mergedObj.length; i++) {
    finalArr.push({
      id: i + 1,
      Name: mergedObj[i].Name,
      Color: mergedObj[i].Color,
      Category: mergedObj[i].Category,
    });
  }
  return finalArr;
}

export function GetAllWorkItemSubStates(): SubState[] {
  const ammsubstateOptions = GetAMMSubStates();
  const substateOptions = GetSubStateOptions();
  const helpsubstateoptions = GetAMMHelpSubStates();
  const mergedObj = [...ammsubstateOptions, ...substateOptions, ...helpsubstateoptions];
  const finalSubStateArr: SubState[] = [];
  for (let i = 0; i < mergedObj.length; i++) {
    finalSubStateArr.push({
      id: i + 1,
      subState: mergedObj[i].subState,
      stateId: mergedObj[i].stateId,
      areapathID: mergedObj[i].areapathID,
    });
  }
  return finalSubStateArr;
}

export const GetAMMSubStates = (): Amm_SubStates[] => GetDropdownOptions('Amm_SubStates');

export const GetAMMHelpWorkItemStates = (): WorkItemState[] =>
  GetDropdownOptions('Amm_HelpWorkItemState');

export function GetAMMHelpStateIdByName(state: string): WorkItemState {
  const stateOptions = GetAMMHelpWorkItemStates();
  return stateOptions?.filter((g) => g.Name === state)[0];
}

export const GetAMMHelpSubStates = (): Amm_SubStates[] => GetDropdownOptions('Amm_HelpSubStates');

export const GetAMMRVToolsExportOptions = (): Amm_RVToolsExport[] =>
  GetDropdownOptions('AMM_DoYouHaveTheRVToolsExport');

export const GetAMMAlreadyRunningAtleast1AVSClusterInTheTargetRegionOptions =
  (): AMM_AlreadyRunningAtleast1AVSClusterInTheTargetRegion[] =>
    GetDropdownOptions('AMM_AlreadyRunningAtleast1AVSClusterInTheTargetRegion');

export const GetAMMAzureRegionOptions = (): AMM_AzureRegion[] =>
  GetDropdownOptions('AMM_AzureRegion');

export const GetAMMNodeTypeOptions = (): AMM_NodeType[] => GetDropdownOptions('AMM_NodeType');

export const GetAMMReservedInstancesOptions = (): AMM_ReservedInstances[] =>
  GetDropdownOptions('AMM_ReservedInstances');

export const GetAMMFTTSettingsOptions = (): AMM_FTTSettings[] =>
  GetDropdownOptions('AMM_FTTSettings');

export const GetAMMCPUOverSubscriptionOptions = (): AMM_CPUOverSubscription[] =>
  GetDropdownOptions('AMM_CPUOverSubscription');

export const GetAMMCurrencyOptions = (): AMM_Currency[] => GetDropdownOptions('AMM_Currency');

export const GetAMMProjectScenarioSelection = (): AMM_ProjectScenarioSelection[] =>
  GetDropdownOptions('AMM_ProjectScenarioSelection');

export const GetAMMIsNominationforFactoryAssessment = (): AMM_IsNominationforFactoryAssessment[] =>
  GetDropdownOptions('AMM_IsNominationforFactoryAssessment');

export const GetAMMDeliveryGroupSelection = (): AMM_DeliveryGroupSelection[] =>
  GetDropdownOptions('AMM_DeliveryGroupSelection');

export const GetAMMConditionsApplyForProject = (): AMM_ConditionsApplyForProject[] =>
  GetDropdownOptions('AMM_ConditionsApplyForProject');

export const GetAMMicensingProgramOptions = (): AMM_LicensingProgram[] =>
  GetDropdownOptions('Amm_LicensingProgram');

export const GetAMMCSPPartnerOptions = (): AMM_CSPPartner[] => GetDropdownOptions('AMM_CSPPartner');

export const GetAMMACOScenarioSelectionOptions = (): AMM_ACOScenarioSelection[] =>
  GetDropdownOptions('AMM_ACOScenarioSelection');

export const GetUatDataDictionaryOptions = (): UATDisplayColumn[] =>
  GetDropdownOptions(UATConstants.EntityMetaDataKeys.UATDataDictionary);

export const GetRoBPriorityOptions = (): Priority[] => {
  const priorityOptions = GetPriorityOptions();
  return priorityOptions?.filter((g) => g.tenant == 'rob');
};

export const GetECIFDealStructure = (): ECIF_DealStructure[] =>
  GetDropdownOptions('ecifDealStructure');

export const GetECIFRequestReason = (): ECIF_RequestReason[] =>
  GetDropdownOptions('ecifRequestReason');

export function GetECIFApprovedOrRejected(): ECIF_ApprovedOrRejectedValues[] {
  return [
    { id: 1, value: 'Approved' },
    { id: 2, value: 'Rejected' },
  ];
}

export const GetOpportunityStatus = (): OpportunityStatus[] => {
  return [
    { id: 1, opportunityStatus: 'Closed' },
    { id: 2, opportunityStatus: 'In Progress' },
    { id: 3, opportunityStatus: 'Open' },
  ];
};

export const GetSchAccountTeamBriefingStatus = (): SchAccountTeamBriefingStatus[] =>
  GetDropdownOptions('SchAccountTeamBriefingStatus');

export const GetSchCustomerBriefingStatus = (): SchCustomerBriefingStatus[] =>
  GetDropdownOptions('SchCustomerBriefingStatus');

export const GetSchGrowthShapingSteps = (): SchGrowthShapingSteps[] =>
  GetDropdownOptions('SchGrowthShapingSteps');

export const GetSchGrowthShapingState = (): SchGrowthShapingState[] =>
  GetDropdownOptions('SchGrowthShapingState');

export const GetSchPrimaryReasonForBlockedOrAtRisk = (): SchPrimaryReasonForBlockedOrAtRisk[] =>
  GetDropdownOptions('SchPrimaryReasonForBlockedOrAtRisk');

export const GetBudgetProgramNameOptions = (): BudgetProgramName[] =>
  GetDropdownOptions('BudgetProgramName');

export const GetLicensingMechanismOptions = (): LicensingMechanism[] =>
  GetDropdownOptions('LicensingMechanism');
export const GetUseCaseOptions = (): UseCase[] => GetDropdownOptions('UseCase');
export const GetWorkTypeOptions = (): WorkType[] => GetDropdownOptions('WorkType');
export const GetCustomerPartnerLocationOptions = (): CustomerPartnerLocation[] =>
  GetDropdownOptions('CustomerPartnerLocation');

export const GetApprovalTypeOptions = (): ApprovalType[] => GetDropdownOptions('GPS_Attachment');

export const GetAccountCohortOptions = (): AccountCohort[] =>
  GetDropdownOptions('sgS_AccountCohort');
export const GetCustomerCommitmentStatusOptions = (): CustomerCommitmentStatus[] =>
  GetDropdownOptions('sgS_CustomerCommitmentStatus');
export const GetGrowthShapingETAOptions = (): GrowthShapingETA[] =>
  GetDropdownOptions('sgS_GrowthSharingETA');
export const GetDcRegionFromOptions = (): DCRegionFrom[] => GetDropdownOptions('sgS_DcRegionFrom');
export const GetDcRegionToOptions = (): DCRegionTo[] => GetDropdownOptions('sgS_DcRegionTo');
export const GetTierOptions = (): TierOptions[] => GetDropdownOptions('sgS_Tier');
export const GetSubTierOptions = (): SubTierOptions[] => GetDropdownOptions('sgS_SubTier');
export const GetTimezonesOptions = (): TimezoneOptions[] => GetDropdownOptions('sgS_Timezones');

//PartnerSkilling Dropdowns
export const GetPartnerSkillingRequestTypeOptions = (): PSRequestTypesOptions[] => GetDropdownOptions('rS_requesttype');
export const GetPartnerSkillingCampaignOptions = (): PSCampainOptions[] => GetDropdownOptions('rS_campaign');
export const GetPartnerSkillingDeliveryLanguageOptions = (): PSDeliveryLanguageOptions[] => GetDropdownOptions('rS_deliverylanguage');
export const GetPartnerSkillingPartnerTypeOptions = (): PSPartnerTypeOptions[] => GetDropdownOptions('rS_partnertype');
export const GetPartnerSkillingCountryOptions = (): PSCountryOptions[] => GetDropdownOptions('rS_partnercountry');
export const GetPartnerSkillingActionOwnerMappingOptions = (): PSActionOwnerMappingOptions[] => GetDropdownOptions('regionalSkilling_ActionOwnerMapping');
export const GetPartnerSkillingPlanStatusOptions = (): PSPlanStatusOptions[] => GetDropdownOptions('rS_skillingplanstatus');
export const GetPartnerSkillingModelOptions = (): PSModelOptions[] => GetDropdownOptions('rS_model');
export const GetPartnerSkillingAccountTypeOptions = (): PSAccountTypeOptions[] => GetDropdownOptions('rS_accounttype');
export const GetPartnerSkillingMeetingCadenceFrequencyOptions = (): PSMeetingCadenceFrequencyOptions[] =>
  GetDropdownOptions('rS_meetingcadencefrequency');


export const GetAMMAVSPilotRegionRequested = (): AMM_AVSPilotRegionRequested[] =>
  GetDropdownOptions('AMM_AVSPilotRegionRequested');

export const GetAMMAVSPilotSKURequested = (): AMM_AVSPilotSKURequested[] =>
  GetDropdownOptions('AMM_AVSPilotSKURequested');

export const GetAMMActionPriorities = (): IAMMActionPriorities[] => GetDropdownOptions('AMM_ActionPriorities');


export const GetAMMExceptionDecision = (): IAMM_Exceptiondecision[] => GetDropdownOptions('Amm_Exceptiondecision');

export const GetAMMExceptionType = (): IAMM_Exceptiontype[] => GetDropdownOptions('Amm_ExceptionType');

export const GetAMMStellerAttestation = (): IAMMSellerAttestation[] => GetDropdownOptions('Amm_SellerAttestation');


export const GetAMMACOReleaseStructure = (): IAMM_ACO_ReleaseStructure[] => GetDropdownOptions('AMM_ACO_ReleaseStructure');

export const GetWillingToSignNewMACC = (): IWillingToSignNewMACC[] => GetDropdownOptions('AMM_MACCStatus');




export const GetAMMCurrencyWithLocale = () => AMM_CurrencyWithLocale;
export const GetAMMCreditExpiration = (): IAMM_CreditExpiration[] => GetDropdownOptions('AMM_CreditExpiration');

export const GetAMMNBARScenario = (): IAMM_NBARScenario[] => GetDropdownOptions('AMM_NBAR_Scenario');
export const GetAMMNBARStatus = (): IAMM_NBAR_Status[] => GetDropdownOptions('AMM_NBAR_Status');
export const GetAMMNBARRejectionReason = (): IAMM_NBAR_RejectionReason[] => GetDropdownOptions('AMM_NBAR_RejectionReason');
export const GetAMMNBARReasonForDelayBeyond3Months = (): IAMM_NBAR_ReasonForDelayBeyond3Months[] => GetDropdownOptions('AMM_NBAR_ReasonForDelayBeyond3Months');
export const GetAMMNBARCommitmentStatus = (): IAMM_NBAR_CommitmentStatus[] => GetDropdownOptions('AMM_NBAR_CommitmentStatus');
export const GetAMMSSCACOOfferOptions = (): AMM_SSCACOOffer[] => GetDropdownOptions('AMM_SSCACOOffer');
// Generated by GitHub Copilot | Updated on: 2026-05-06 | 4 lines modified | Added AMM_SSCACOOffer dropdown model import and getter function

export const GetAMMBigAreaOptions = (): AMM_BigArea[] => GetDropdownOptions('AMM_BigArea');

export const GetAMMECIFFactoryConditions = (): AMM_ECIFFactoryConditions[] =>
  GetDropdownOptions('AMM_ECIFFactoryConditions');

export const GetAMMFactoryBenefits = (): AMM_FactoryBenefits[] =>
  GetDropdownOptions('AMM_FactoryBenefits');

export const GetAMMReasonForNotAcceptingSplit = (): AMM_ReasonForNotAcceptingSplit[] =>
  GetDropdownOptions('AMM_ReasonForNotAcceptingSplit');

export const GetAMMPartnerSpecializationConfirmationOptions =
  (): AMM_PartnerSpecializationConfirmation[] =>
    GetDropdownOptions('AMM_PartnerSpecializationConfirmation');


// Generated by GitHub Copilot | Updated on: 2026-06-12 | 4 lines modified | Added AMM_BigArea dropdown model import and getter function
// Generated by GitHub Copilot | Updated on: 2026-06-18 | 3 lines modified | Added RB_Tier import and GetTierOptions function for rb_tier cosmos dropdown
// Generated by GitHub Copilot | Updated on: 2026-07-02 | 1 lines modified | Added GetRequestUrgencyValues + Request Urgency filter option (WI #138509)
// Generated by GitHub Copilot | Updated on: 2026-07-02 | 15 lines modified | GetRequestUrgencyValues returns predefined options (backend dropdown feed absent) (WI #138509)
// Generated by GitHub Copilot | Updated on: 2026-07-06 | 15 lines modified | De-hardcoded Request Urgency: removed RequestUrgencyPredefinedOptions, GetRequestUrgencyValues now reads Cosmos feed via GetDropdownOptions('request_urgency') (WI #138509)
// Generated by GitHub Copilot | Updated on: 2026-07-08 | 3 lines added | Added UOMValues import, GetUOMValues getter and 'Unit of Measurement' filter dict entry (WI #138593)
// Generated by GitHub Copilot | Updated on: 2026-07-15 | 3 lines added | Added GetGPSAccountingTreatmentOptions getter for GPS download-template dropdown
// Generated by GitHub Copilot | Updated on: 2026-08-25 | 4 lines added | Added GetPartnerSkillingModelOptions and GetPartnerSkillingAccountTypeOptions for Regional Skilling
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 16 lines modified | Normalized GPS survey dropdown option values
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 6 lines modified | Preserved survey urgency numeric IDs
// Generated by GitHub Copilot | Updated on: 2026-09-22 | 3 lines modified | Filter retired Non-AI request type
// Generated by GitHub Copilot | Updated on: 2026-09-28 | 3 lines modified | Filter retired create option
// Generated by GitHub Copilot | Updated on: 2026-10-05 | 3 lines modified | Restored all Non-AI request types
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 1 line modified | Bug 150770: Add AOAI model export dropdown
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 120 lines modified | Remove unrelated formatting from AOAI fix
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 120 lines modified | Export all AOAI models; restore original formatting
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 120 lines modified | Remove formatting-only changes; retain AOAI fix
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 12 lines modified | Filter deprecated AOAI export models
// Generated by GitHub Copilot | Updated on: 2026-10-22 | Copilot: Reconcile proven source/GHE deltas; preserve both histories.
// Generated by GitHub Copilot | Updated on: 2026-10-23 | 3 lines added | Loaded configured meeting cadence options
// Copilot change tracking: 2026-11-01 migration: Retain frozen release reconciliation.
// Copilot change tracking: 2026-11-01 frontend lint: Use const for an unchanged dropdown binding.
// Copilot change tracking: 2026-11-02 frontend: Type caller-used lookup values and remove unused imports.
// Copilot change tracking: 2026-11-02 frontend-unused: Explicitly discard compatibility tenant arguments while retaining public signatures.
// Copilot change tracking: 2026-11-02 frontend-regressions: Accept missing optional area identifiers and guard subsegment lookup conversion.
